webpackJsonp([1],{

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebaseconfig_apiconfig__ = __webpack_require__(444);
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_1__firebaseconfig_apiconfig__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PostSubmitForm__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ShowTsuraiTimeline__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ShowEraiTimeline__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NowLoading__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PostingButton__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ismobilejs__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ismobilejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_ismobilejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var db = __WEBPACK_IMPORTED_MODULE_7_firebase___default.a.firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Timeline',
  components: {
    'post-submit-form': __WEBPACK_IMPORTED_MODULE_2__components_PostSubmitForm__["a" /* default */],
    'show-tsurai-timeline': __WEBPACK_IMPORTED_MODULE_3__components_ShowTsuraiTimeline__["a" /* default */],
    'show-erai-timeline': __WEBPACK_IMPORTED_MODULE_4__components_ShowEraiTimeline__["a" /* default */],
    'common-header': __WEBPACK_IMPORTED_MODULE_5__components_Header__["a" /* default */],
    'now-loading': __WEBPACK_IMPORTED_MODULE_6__components_NowLoading__["a" /* default */],
    'posting-button': __WEBPACK_IMPORTED_MODULE_8__components_PostingButton__["a" /* default */],
    'infinity-loading': __WEBPACK_IMPORTED_MODULE_10_vue_infinite_loading___default.a

  },
  data: function data() {
    return {
      showLength: 30,
      showMoreNum: 10,
      isLoading: true,
      showPostModal: false,
      isMobile: __WEBPACK_IMPORTED_MODULE_9_ismobilejs___default.a.any
    };
  },

  watch: {
    mode: function mode(newMode, oldMode) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(newMode === 'tsurai')) {
                  _context.next = 5;
                  break;
                }

                _this.startLoading();
                _context.next = 4;
                return _this.$store.dispatch('getTsuraiTimeline');

              case 4:
                _this.endLoading();

              case 5:
                if (!(newMode === 'erai')) {
                  _context.next = 10;
                  break;
                }

                _this.startLoading();
                _context.next = 9;
                return _this.$store.dispatch('getEraiTimeline');

              case 9:
                _this.endLoading();

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;

    this.startLoading();
    this.$store.dispatch('getLoginState');
    this.$store.dispatch('getUserInfoState');
    db.collection('posts').onSnapshot(function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(querySnapshot) {
        var newPosts, limitedNewPosts;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newPosts = [];

                querySnapshot.forEach(function (doc) {
                  var docData = doc.data();
                  docData.id = doc.id;
                  newPosts.push(docData);
                });
                newPosts.sort(function (a, b) {
                  if (a.created_at > b.created_at) return -1;else return 1;
                });
                limitedNewPosts = [];

                newPosts.forEach(function (doc, idx) {
                  if (idx < _this2.showLength) {
                    limitedNewPosts.push(doc);
                  }
                });
                _context2.next = 7;
                return _this2.$store.dispatch('getTsuraiTimeline', { newPosts: limitedNewPosts, numPosts: _this2.showLength });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    db.collection('posts_erai').onSnapshot(function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(querySnapshot) {
        var newPosts, limitedNewPosts;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newPosts = [];

                querySnapshot.forEach(function (doc) {
                  var docData = doc.data();
                  docData.id = doc.id;
                  newPosts.push(docData);
                });
                newPosts.sort(function (a, b) {
                  if (a.created_at > b.created_at) return -1;else return 1;
                });
                limitedNewPosts = [];

                newPosts.forEach(function (doc, idx) {
                  if (idx < _this2.showLength) {
                    limitedNewPosts.push(doc);
                  }
                });
                _context3.next = 7;
                return _this2.$store.dispatch('getEraiTimeline', { newPosts: limitedNewPosts, numPosts: _this2.showLength });

              case 7:
                _this2.endLoading();

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  },

  computed: {
    mode: function mode() {
      return this.$route.params.mode;
    },
    posts: function posts() {
      return this.mode === 'tsurai' ? this.$store.state.postsTsurai : this.$store.state.postsErai;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    username: function username() {
      return this.$store.state.userInfo.username;
    },
    user_id: function user_id() {
      return this.$store.state.userInfo.auth_id;
    },
    timelineBg: function timelineBg() {
      return this.mode === 'tsurai' ? 'timeline-background-tsurai' : 'timeline-background-erai';
    }
  },
  methods: {
    startLoading: function startLoading() {
      this.isLoading = true;
      document.body.style.height = '100%';
    },
    endLoading: function endLoading() {
      this.isLoading = false;
      document.body.style.height = 'auto';
    },
    infiniteHandler: function infiniteHandler(state) {
      var _this3 = this;

      var prelength = this.posts.length;
      this.showMore().then(function () {
        if (prelength !== _this3.posts.length) {
          state.loaded();
        } else {
          state.complete();
        }
      }).catch(function (e) {
        return alert('データを正常に読み込めませんでした');
      });
    },
    showMore: function showMore() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.showLength += _this4.showMoreNum;

                if (!(_this4.mode === 'tsurai')) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return _this4.$store.dispatch('getTsuraiTimeline', { newPosts: undefined, numPosts: _this4.showLength });

              case 4:
                if (!(_this4.mode === 'erai')) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 7;
                return _this4.$store.dispatch('getEraiTimeline', { newPosts: undefined, numPosts: _this4.showLength });

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    popPost: function popPost() {
      this.showPostModal = true;
    },
    closeModal: function closeModal() {
      this.showPostModal = false;
    },
    toTop: function toTop() {
      scrollTo(0, 0);
    },
    toHome: function toHome() {
      this.$router.push('/user/' + this.user_id);
    }
  }
});

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var firestore = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
  template: '#modal-template',
  data: function data() {
    return {
      text: '',
      isProcessing: false
    };
  },

  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    showModal: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      required: true
    }
  },
  computed: {
    placeholderMassage: function placeholderMassage() {
      if (this.mode === 'tsurai') {
        return '今日のつらかったこと';
      }
      if (this.mode === 'erai') {
        return '今日やったえらいこと';
      }
      return '';
    },
    username: function username() {
      return this.$store.state.userInfo.username;
    },
    user_id: function user_id() {
      return this.$store.state.userInfo.user_id;
    },
    postFormStyle: function postFormStyle() {
      return this.mode === 'tsurai' ? 'post-form-tsurai' : 'post-form-erai';
    },
    postButtonStyle: function postButtonStyle() {
      return this.mode === 'tsurai' ? 'post-btn-tsurai' : 'post-btn-erai';
    }
  },
  methods: {
    startProcessing: function startProcessing() {
      this.isProcessing = true;
    },
    endProcessing: function endProcessing() {
      this.isProcessing = false;
    },
    sendPost: function sendPost() {
      var _this = this;

      if (this.text === '') {
        alert('投稿内容を入力してください');
        return;
      }
      if (this.text.length > 140) {
        alert('投稿は140文字以内にしてください');
        return;
      }
      if (this.mode === 'tsurai') {
        this.startProcessing();
        firestore.collection('posts').add({
          username: this.username,
          body: this.text,
          created_at: new Date().getTime(),
          enable: true,
          that_is_too_bad_list: [],
          you_are_alright_list: [],
          good_job_list: [],
          author: firestore.doc('/users/' + this.user_id)
        }).then(function (res) {
          _this.clearForm();
          _this.$store.dispatch('getTsuraiTimeline');
          _this.endProcessing();
        }).catch(function (e) {
          _this.endProcessing();
        });
      }
      if (this.mode === 'erai') {
        this.startProcessing();
        firestore.collection('posts_erai').add({
          username: this.username,
          body: this.text,
          created_at: new Date().getTime(),
          enable: true,
          great_list: [],
          congrat_list: [],
          genius_list: [],
          author: firestore.doc('/users/' + this.user_id)
        }).then(function (res) {
          _this.clearForm();
          _this.$store.dispatch('getEraiTimeline');
          _this.endProcessing();
        }).catch(function (e) {
          _this.endProcessing();
        });
      }
    },
    clearForm: function clearForm() {
      this.text = '';
    }
  }
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowTsuraiTimeline_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69faa268_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowTsuraiTimeline_vue__ = __webpack_require__(508);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69faa268"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowTsuraiTimeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69faa268_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowTsuraiTimeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Stamp__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icon_Twitter__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_postDeletable__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_stampHandler__ = __webpack_require__(217);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Timeline',
  components: {
    'v-icon': __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */],
    'stamp': __WEBPACK_IMPORTED_MODULE_1__components_Stamp__["a" /* default */],
    'twitter-icon': __WEBPACK_IMPORTED_MODULE_2__components_icon_Twitter__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_postDeletable__["a" /* postDeletable */], __WEBPACK_IMPORTED_MODULE_4__mixins_stampHandler__["a" /* stampHandler */]],
  created: function created() {},

  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    twiUrl: function twiUrl() {
      return 'https://twitter.com/intent/tweet?text=' + this.post.posts.body + '&hashtags=\u4ECA\u65E5\u306E\u3064\u3089\u3044&url=https://sorehatsurai.firebaseapp.com';
    },
    num_that_is_too_bad: function num_that_is_too_bad() {
      return this.post.posts.that_is_too_bad_list.length;
    },
    num_you_are_alright: function num_you_are_alright() {
      return this.post.posts.you_are_alright_list.length;
    },
    num_good_job: function num_good_job() {
      return this.post.posts.good_job_list.length;
    },
    formattedCreatedTime: function formattedCreatedTime() {
      var d = new Date(this.post.posts.created_at * 1);
      var formattedMinutes = ('00' + d.getMinutes()).slice(-2);
      return d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate() + ' ' + d.getHours() + ':' + formattedMinutes;
    },
    user_id: function user_id() {
      return this.$store.state.userInfo.user_id;
    },
    iconURL: function iconURL() {
      if (this.post.author.icon_URL !== '') return this.post.author.icon_URL;
      return '/static/dummyicon/dummyicon' + String(this.author_auth_id.charCodeAt(0) % 12 + 1) + '.png';
    },
    author_auth_id: function author_auth_id() {
      return this.post.author.auth_id;
    },
    isAuthor: function isAuthor() {
      if (this.user_id === undefined) return false;
      return this.user_id === this.post.author.user_id;
    }
  }
});

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    title: String,
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String,
    tabindex: [Number, String]
  },
  data: function data() {
    return {
      id: getId(),
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    },
    focusable: function focusable() {
      var tabindex = this.tabindex;

      if (tabindex == null) {
        return 'false';
      }
      var index = typeof tabindex === 'string' ? parseInt(tabindex, 10) : tabindex;
      if (index >= 0) {
        return null;
      }
      return 'false';
    }
  },
  mounted: function mounted() {
    this.updateStack();
  },
  updated: function updated() {
    this.updateStack();
  },

  methods: {
    updateStack: function updateStack() {
      var _this = this;

      if (!this.name && this.name !== null && this.$children.length === 0) {
        console.warn('Invalid prop: prop "name" is required.');
        return;
      }

      if (this.icon) {
        return;
      }

      var width = 0;
      var height = 0;
      this.$children.forEach(function (child) {
        child.outerScale = _this.normalizedScale;

        width = Math.max(width, child.width);
        height = Math.max(height, child.height);
      });
      this.childrenWidth = width;
      this.childrenHeight = height;
      this.$children.forEach(function (child) {
        child.x = (width - child.width) / 2;
        child.y = (height - child.height) / 2;
      });
    }
  },
  render: function render(h) {
    if (this.name === null) {
      return h();
    }

    var options = {
      class: this.klass,
      style: this.style,
      attrs: {
        role: this.$attrs.role || (this.label || this.title ? 'img' : null),
        'aria-label': this.label || null,
        'aria-hidden': String(!(this.label || this.title)),
        tabindex: this.tabindex,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        viewBox: this.box,
        focusable: this.focusable
      }
    };

    var titleId = 'vat-' + this.id;
    if (this.title) {
      options.attrs['aria-labelledby'] = titleId;
    }

    if (this.raw) {
      var html = this.raw;

      if (this.title) {
        html = '<title id="' + titleId + '">' + escapeHTML(this.title) + '</title>' + html;
      }

      options.domProps = {
        innerHTML: html
      };
    }

    var content = this.title ? [h('title', { attrs: { id: titleId } }, this.title)] : [];

    return h('svg', options, this.raw ? null : content.concat(this.$slots.default || [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.paths.map(function (path, i) {
      return h('path', {
        attrs: path,
        key: 'path-' + i
      });
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.polygons.map(function (polygon, i) {
      return h('polygon', {
        attrs: polygon,
        key: 'polygon-' + i
      });
    })))));
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];
      var _icon$paths = icon.paths,
          paths = _icon$paths === undefined ? [] : _icon$paths,
          d = icon.d,
          _icon$polygons = icon.polygons,
          polygons = _icon$polygons === undefined ? [] : _icon$polygons,
          points = icon.points;


      if (d) {
        paths.push({ d: d });
      }

      if (points) {
        polygons.push({ points: points });
      }

      icons[name] = assign({}, icon, {
        paths: paths,
        polygons: polygons
      });
    }
  },

  icons: icons
});

function assign(obj) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        obj[key] = source[key];
      }
    }
  });

  return obj;
}

var cursor = 0xd4937;
function getId() {
  return 'va-' + (cursor++).toString(16);
}

var ESCAPE_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
};

function escapeHTML(html) {
  return html.replace(/[<>"&]/g, function (c) {
    return ESCAPE_MAP[c] || c;
  });
}

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stamp_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d409258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stamp_vue__ = __webpack_require__(506);
function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stamp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d409258_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stamp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icon_TooBad__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icon_AllRight__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icon_Congrat__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icon_Great__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icon_GoodJob__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_icon_Genius__ = __webpack_require__(504);
//
//
//
//
//
//
//
//
//
//
//
//
//








var iconTable = {
  'too-bad': { component: __WEBPACK_IMPORTED_MODULE_0__components_icon_TooBad__["a" /* default */], color: '#7892d6', inactiveColor: 'gray', numColor: 'rgba(255, 255, 255, 0.7)' },
  'alright': { component: __WEBPACK_IMPORTED_MODULE_1__components_icon_AllRight__["a" /* default */], color: '#bd4f6c', inactiveColor: 'gray', numColor: 'rgba(255, 255, 255, 0.7)' },
  'good-job': { component: __WEBPACK_IMPORTED_MODULE_4__components_icon_GoodJob__["a" /* default */], color: '#51a3a3', inactiveColor: 'gray', numColor: 'rgba(255, 255, 255, 0.7)' },
  'great': { component: __WEBPACK_IMPORTED_MODULE_3__components_icon_Great__["a" /* default */], color: '#f4a55f', inactiveColor: 'gray', numColor: 'rgba(18, 21, 37, 0.54)' },
  'congrat': { component: __WEBPACK_IMPORTED_MODULE_2__components_icon_Congrat__["a" /* default */], color: '#bd4f6c', inactiveColor: 'gray', numColor: 'rgba(18, 21, 37, 0.54)' },
  'genius': { component: __WEBPACK_IMPORTED_MODULE_5__components_icon_Genius__["a" /* default */], color: '#51a3a3', inactiveColor: 'gray', numColor: 'rgba(18, 21, 37, 0.54)' }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Stamp',
  components: {
    TooBad: __WEBPACK_IMPORTED_MODULE_0__components_icon_TooBad__["a" /* default */],
    AllRight: __WEBPACK_IMPORTED_MODULE_1__components_icon_AllRight__["a" /* default */],
    Congrat: __WEBPACK_IMPORTED_MODULE_2__components_icon_Congrat__["a" /* default */],
    Great: __WEBPACK_IMPORTED_MODULE_3__components_icon_Great__["a" /* default */],
    GoodJob: __WEBPACK_IMPORTED_MODULE_4__components_icon_GoodJob__["a" /* default */],
    Genius: __WEBPACK_IMPORTED_MODULE_5__components_icon_Genius__["a" /* default */]
  },
  data: function data() {
    return {
      width: 20,
      height: 20,
      stampCounter: {
        color: this.stampCounterColor,
        paddingRight: '4px'
      }
    };
  },

  props: {
    kind: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: 0
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    stampComponent: function stampComponent() {
      var res = iconTable[this.kind];
      return res.component;
    },
    stampColor: function stampColor() {
      var res = iconTable[this.kind];
      return this.active ? res.color : res.inactiveColor;
    },
    stampCounterColor: function stampCounterColor() {
      var res = iconTable[this.kind];
      return res.stampColor;
    }
  },
  methods: {
    click: function click() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    iconColor: {
      type: String,
      default: 'gray'
    }
  }
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    iconColor: {
      type: String,
      default: 'gray'
    }
  }
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    iconColor: {
      type: String,
      default: 'gray'
    }
  }
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    iconColor: {
      type: String,
      default: 'gray'
    }
  }
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    iconColor: {
      type: String,
      default: 'gray'
    }
  }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    iconColor: {
      type: String,
      default: 'gray'
    }
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0aac178_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Twitter_vue__ = __webpack_require__(507);
var normalizeComponent = __webpack_require__(9)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0aac178_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Twitter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return postDeletable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);

var firestore = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();

var postDeletable = {
  methods: {
    deletePost: function deletePost() {
      if (confirm('投稿を削除しますか?')) {
        firestore.collection('posts').doc(this.post.posts.id).delete().then(function () {
          alert('投稿が削除されました');
        }).catch(function (e) {
          return alert('投稿を削除できませんでした。管理者にお問い合わせください。');
        });
      }
    }
  }
};

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stampHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);

var firestore = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore();

var stampHandler = {
  methods: {
    toggle_great: function toggle_great() {
      var _this = this;

      if (!this.$store.state.isLoggedIn) {
        alert('スタンプを押すにはログインしてください');
        return;
      }
      var newRef = firestore.doc('/users/' + this.user_id);
      var idList = this.post.posts.great_id_list;
      var index = idList.findIndex(function (item) {
        return item === _this.user_id;
      });
      if (index === -1) {
        firestore.collection('posts_erai').doc(this.post.posts.id).update({
          great_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayUnion(newRef)
        });
      } else {
        firestore.collection('posts_erai').doc(this.post.posts.id).update({
          great_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayRemove(newRef)
        });
      }
    },
    toggle_congrat: function toggle_congrat() {
      var _this2 = this;

      if (!this.$store.state.isLoggedIn) {
        alert('スタンプを押すにはログインしてください');
        return;
      }
      var newRef = firestore.doc('/users/' + this.user_id);
      var idList = this.post.posts.congrat_id_list;
      var index = idList.findIndex(function (item) {
        return item === _this2.user_id;
      });
      if (index === -1) {
        firestore.collection('posts_erai').doc(this.post.posts.id).update({
          congrat_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayUnion(newRef)
        });
      } else {
        firestore.collection('posts_erai').doc(this.post.posts.id).update({
          congrat_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayRemove(newRef)
        });
      }
    },
    toggle_genius: function toggle_genius() {
      var _this3 = this;

      if (!this.$store.state.isLoggedIn) {
        alert('スタンプを押すにはログインしてください');
        return;
      }
      var newRef = firestore.doc('/users/' + this.user_id);
      var idList = this.post.posts.genius_id_list;
      var index = idList.findIndex(function (item) {
        return item === _this3.user_id;
      });
      if (index === -1) {
        firestore.collection('posts_erai').doc(this.post.posts.id).update({
          genius_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayUnion(newRef)
        });
      } else {
        firestore.collection('posts_erai').doc(this.post.posts.id).update({
          genius_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayRemove(newRef)
        });
      }
    },
    toggle_too_bad: function toggle_too_bad() {
      var _this4 = this;

      if (!this.$store.state.isLoggedIn) {
        alert('スタンプを押すにはログインしてください');
        return;
      }
      var newRef = firestore.doc('/users/' + this.user_id);
      var idList = this.post.posts.too_bad_id_list;
      var index = idList.findIndex(function (item) {
        return item === _this4.user_id;
      });
      if (index === -1) {
        firestore.collection('posts').doc(this.post.posts.id).update({
          that_is_too_bad_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayUnion(newRef)
        });
      } else {
        firestore.collection('posts').doc(this.post.posts.id).update({
          that_is_too_bad_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayRemove(newRef)
        });
      }
    },
    toggle_alright: function toggle_alright() {
      var _this5 = this;

      if (!this.$store.state.isLoggedIn) {
        alert('スタンプを押すにはログインしてください');
        return;
      }
      var newRef = firestore.doc('/users/' + this.user_id);
      var idList = this.post.posts.alright_id_list;
      var index = idList.findIndex(function (item) {
        return item === _this5.user_id;
      });
      if (index === -1) {
        firestore.collection('posts').doc(this.post.posts.id).update({
          you_are_alright_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayUnion(newRef)
        });
      } else {
        firestore.collection('posts').doc(this.post.posts.id).update({
          you_are_alright_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayRemove(newRef)
        });
      }
    },
    toggle_good_job: function toggle_good_job() {
      var _this6 = this;

      if (!this.$store.state.isLoggedIn) {
        alert('スタンプを押すにはログインしてください');
        return;
      }
      var newRef = firestore.doc('/users/' + this.user_id);
      var idList = this.post.posts.good_job_id_list;
      var index = idList.findIndex(function (item) {
        return item === _this6.user_id;
      });
      if (index === -1) {
        firestore.collection('posts').doc(this.post.posts.id).update({
          good_job_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayUnion(newRef)
        });
      } else {
        firestore.collection('posts').doc(this.post.posts.id).update({
          good_job_list: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.firestore.FieldValue.arrayRemove(newRef)
        });
      }
    },
    isActive: function isActive(stampType) {
      if (this.user_id === undefined) return false;
      switch (stampType) {
        case 'great':
          return this.post.posts.great_id_list.includes(this.user_id);
        case 'congrat':
          return this.post.posts.congrat_id_list.includes(this.user_id);
        case 'genius':
          return this.post.posts.genius_id_list.includes(this.user_id);
        case 'too-bad':
          return this.post.posts.too_bad_id_list.includes(this.user_id);
        case 'alright':
          return this.post.posts.alright_id_list.includes(this.user_id);
        case 'good-job':
          return this.post.posts.good_job_id_list.includes(this.user_id);
      }
      return false;
    }
  }
};

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowEraiTimeline_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b69493f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowEraiTimeline_vue__ = __webpack_require__(510);
function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b69493f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowEraiTimeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b69493f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowEraiTimeline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Stamp__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icon_Twitter__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_postDeletable__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_stampHandler__ = __webpack_require__(217);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Timeline',
  components: {
    'v-icon': __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */],
    'stamp': __WEBPACK_IMPORTED_MODULE_1__components_Stamp__["a" /* default */],
    'twitter-icon': __WEBPACK_IMPORTED_MODULE_2__components_icon_Twitter__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_postDeletable__["a" /* postDeletable */], __WEBPACK_IMPORTED_MODULE_4__mixins_stampHandler__["a" /* stampHandler */]],
  created: function created() {},

  props: {
    post: {
      type: Object,
      required: true
    }
  },
  computed: {
    twiUrl: function twiUrl() {
      return 'https://twitter.com/intent/tweet?text=' + this.post.posts.body + '&hashtags=\u4ECA\u65E5\u306E\u3048\u3089\u3044&url=https://sorehatsurai.firebaseapp.com';
    },
    num_great: function num_great() {
      return this.post.posts.great_list.length;
    },
    num_congrat: function num_congrat() {
      return this.post.posts.congrat_list.length;
    },
    num_genius: function num_genius() {
      return this.post.posts.genius_list.length;
    },
    formattedCreatedTime: function formattedCreatedTime() {
      var d = new Date(this.post.posts.created_at * 1);
      var formattedMinutes = ('00' + d.getMinutes()).slice(-2);
      return d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate() + ' ' + d.getHours() + ':' + formattedMinutes;
    },
    user_id: function user_id() {
      return this.$store.state.userInfo.user_id;
    },
    iconURL: function iconURL() {
      if (this.post.author.icon_URL !== '') return this.post.author.icon_URL;
      return '/static/dummyicon/dummyicon' + String(this.author_auth_id.charCodeAt(0) % 12 + 1) + '.png';
    },
    author_auth_id: function author_auth_id() {
      return this.post.author.auth_id;
    },
    isAuthor: function isAuthor() {
      if (this.user_id === undefined) return false;
      return this.user_id === this.post.author.user_id;
    }
  }
});

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_logo_whiteLogo__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_logo_blackLogo__ = __webpack_require__(514);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  computed: {
    userAuthId: function userAuthId() {
      return this.$store.state.userInfo.auth_id;
    },
    headerBg: function headerBg() {
      if (this.mode === 'tsurai') return 'header-bg-tsurai';
      if (this.mode === 'erai') return 'header-bg-erai';
      return 'header-bg-other';
    },
    headerContent: function headerContent() {
      if (this.mode === 'tsurai') return 'header-content-tsurai';
      if (this.mode === 'erai') return 'header-content-erai';
      return 'header-content-other';
    },
    logoComponent: function logoComponent() {
      if (this.mode === 'tsurai') return __WEBPACK_IMPORTED_MODULE_1__components_logo_whiteLogo__["a" /* default */];
      return __WEBPACK_IMPORTED_MODULE_2__components_logo_blackLogo__["a" /* default */];
    }
  },
  methods: {
    signOut: function signOut() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
        _this.$store.dispatch('getLoginState');
        _this.$store.dispatch('getUserInfoState');
        _this.$router.push('/signin');
      });
    }
  }
});

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NowLoading_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6735351c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NowLoading_vue__ = __webpack_require__(518);
function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6735351c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NowLoading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6735351c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NowLoading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__(35);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'v-icon': __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */]
  }
});

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__(35);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'v-icon': __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */]
  },
  props: {
    mode: {
      type: String,
      required: true
    }
  },
  computed: {
    postButtonStyle: function postButtonStyle() {
      return this.mode === 'tsurai' ? 'post-button-tsurai' : 'post-button-erai';
    }
  },
  methods: {
    clickItem: function clickItem() {
      this.$emit('popPost');
    }
  }
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_signInWithProvider__ = __webpack_require__(226);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var firestore = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signup',
  data: function data() {
    return {
      email: '',
      password: '',
      passwordConfirm: '',
      username: '',
      twitter: '',
      isProcessing: false
    };
  },

  components: {
    'common-header': __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],
    'v-icon': __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_signInWithProvider__["a" /* signInWithProvider */]],
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('getLoginState');

            case 2:
              if (_this.isLoggedIn) {
                _this.$router.replace('/timeline');
              }

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.state.isLoggedIn;
    }
  },
  methods: {
    addUserInfo: function addUserInfo() {
      var _this2 = this;

      if (this.password !== this.passwordConfirm) {
        alert('パスワードを確認してください');
        return;
      }
      if (this.username.length > 10) {
        alert('ハンドルネームは10文字以内にしてください');
        return;
      }
      if (this.twitter.length > 30) {
        alert('Twitter IDが長すぎます');
        return;
      }
      var twitterPattern = /^@[a-zA-Z0-9_]+$/;
      var regMatch = this.twitter.match(twitterPattern);
      if (!!this.twitter && regMatch === null) {
        alert('Twiiter IDは1文字目が@でかつ半角英数字とアンダーバーのみしか入力できません');
        return;
      }
      this.twitter = !this.twitter ? '' : regMatch[0];
      this.startProcessing();
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().onAuthStateChanged(function (user) {
          if (user) {
            firestore.collection('users').add({
              auth_id: user.uid,
              icon_URL: '',
              last_login: new Date(),
              twitter: _this2.twitter,
              username: _this2.username
            });
          }
        });
        _this2.endProcessing();
        _this2.$router.push('/timeline/tsurai');
      }).catch(function (e) {
        if (e.code === 'auth/invalid-email') {
          alert('適切なメールアドレスを入力してください');
        }
        if (e.code === 'auth/weak-password') {
          alert('パスワードは6文字以上に設定してください');
        }
        _this2.endProcessing();
      });
    }
  }
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return signInWithProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);



var firestore = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();

var signInWithProvider = {
  methods: {
    startProcessing: function startProcessing() {
      this.isProcessing = true;
    },
    endProcessing: function endProcessing() {
      this.isProcessing = false;
    },
    signInWithGoogle: function signInWithGoogle() {
      var _this = this;

      var provider = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signInWithPopup(provider).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var isFirstLogin;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.startProcessing();
                  isFirstLogin = true;
                  _context.next = 4;
                  return firestore.collection('users').get().then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                      if (doc.data().auth_id === result.user.uid) isFirstLogin = false;
                    });
                  });

                case 4:
                  if (isFirstLogin) {
                    firestore.collection('users').add({
                      auth_id: result.user.uid,
                      icon_URL: '',
                      last_login: new Date(),
                      twitter: '',
                      username: ''
                    });
                  }
                  _this.$router.push('timeline/tsurai');
                  _this.endProcessing();

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this.endProcessing();
      });
    },
    signInWithTwitter: function signInWithTwitter() {
      var _this2 = this;

      var provider = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.TwitterAuthProvider();
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signInWithPopup(provider).then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var isFirstLogin;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.startProcessing();
                  isFirstLogin = true;

                  firestore.collection('users').get().then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                      if (doc.data().auth_id === result.user.uid) isFirstLogin = false;
                    });
                  });
                  if (isFirstLogin) {
                    firestore.collection('users').add({
                      auth_id: result.user.uid,
                      icon_URL: '',
                      last_login: new Date(),
                      twitter: '',
                      username: ''
                    });
                  }
                  _this2.$router.push('timeline/tsurai');
                  _this2.endProcessing();

                case 6:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (e) {
        console.error(e);
        _this2.endProcessing();
      });
    }
  }
};

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Header__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_signInWithProvider__ = __webpack_require__(226);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var db = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signin',
  components: {
    'common-header': __WEBPACK_IMPORTED_MODULE_3__components_Header__["a" /* default */],
    'v-icon': __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_signInWithProvider__["a" /* signInWithProvider */]],
  data: function data() {
    return {
      email: '',
      password: '',
      isProcessing: false
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('getLoginState');

            case 2:
              if (_this.isLoggedIn) {
                _this.$router.replace('/timeline');
              }

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.state.isLoggedIn;
    }
  },
  methods: {
    confirmUserInfo: function confirmUserInfo() {
      var _this2 = this;

      this.startProcessing();
      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(user) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.$store.dispatch('getVisitedUserInfoState', user.user.uid);

                case 2:
                  db.collection('users').doc(_this2.$store.state.visitedUserInfo.user_id).update({
                    last_login: new Date()
                  });
                  _this2.endProcessing();
                  _this2.$router.push('/timeline/tsurai');

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (e) {
        alert('ログインできません');
        _this2.endProcessing();
      });
    }
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Header__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NowLoading__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ShowTsuraiTimeline__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ShowEraiTimeline__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ImageUploadForm__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_firebase__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var db = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'common-header': __WEBPACK_IMPORTED_MODULE_4__components_Header__["a" /* default */],
    'show-tsurai-timeline': __WEBPACK_IMPORTED_MODULE_6__components_ShowTsuraiTimeline__["a" /* default */],
    'show-erai-timeline': __WEBPACK_IMPORTED_MODULE_7__components_ShowEraiTimeline__["a" /* default */],
    'now-loading': __WEBPACK_IMPORTED_MODULE_5__components_NowLoading__["a" /* default */],
    'image-upload-form': __WEBPACK_IMPORTED_MODULE_8__components_ImageUploadForm__["a" /* default */],
    'infinity-loading': __WEBPACK_IMPORTED_MODULE_9_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      isEditing: false,
      isLoading: true,
      editedUserInfo: this.visitedUserInfo,
      searchTsuraiPostsNum: 30,
      searchEraiPostsNum: 30,
      showMoreNum: 100
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.dispatch('getLoginState');
              _this.$store.dispatch('getUserInfoState');
              _this.$store.dispatch('getVisitedUserInfoState', _this.visitedUserID);
              _context.next = 5;
              return _this.$store.dispatch('getTsuraiTimeline', { newPosts: undefined, numPosts: _this.searchTsuraiPostsNum });

            case 5:
              _context.next = 7;
              return _this.$store.dispatch('getEraiTimeline', { newPosts: undefined, numPosts: _this.searchEraiPostsNum });

            case 7:
              _this.isLoading = false;

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    visitingUserInfo: function visitingUserInfo() {
      return this.$store.state.userInfo;
    },
    visitedUserID: function visitedUserID() {
      return this.$route.params.id;
    },
    visitedUserInfo: function visitedUserInfo() {
      return this.$store.state.visitedUserInfo;
    },
    isMyPage: function isMyPage() {
      return this.visitedUserID === this.visitingUserInfo.auth_id;
    },
    twitterLink: function twitterLink() {
      var twitterPattern = /^@([a-zA-Z0-9_]+)$/;
      var basename = this.visitedUserInfo.twitter.match(twitterPattern);
      if (basename !== null) {
        return 'https://twitter.com/' + basename[1];
      }
      return undefined;
    },
    userTsuraiPosts: function userTsuraiPosts() {
      var timeline = this.$store.state.postsTsurai;
      var posts = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(timeline)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          if (timeline[k].author.user_id === this.visitedUserInfo.user_id) {
            posts.push(timeline[k]);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return posts;
    },
    userEraiPosts: function userEraiPosts() {
      var timeline = this.$store.state.postsErai;
      var posts = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(timeline)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var k = _step2.value;

          if (timeline[k].author.user_id === this.visitedUserInfo.user_id) {
            posts.push(timeline[k]);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return posts;
    }
  },
  methods: {
    showMore: function showMore(infinityId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(infinityId === 0)) {
                  _context2.next = 6;
                  break;
                }

                _this2.searchTsuraiPostsNum += _this2.showMoreNum;
                _context2.next = 4;
                return _this2.$store.dispatch('getTsuraiTimeline', { newPosts: undefined, numPosts: _this2.searchTsuraiPostsNum });

              case 4:
                _context2.next = 9;
                break;

              case 6:
                _this2.searchEraiPostsNum += _this2.showMoreNum;
                _context2.next = 9;
                return _this2.$store.dispatch('getEraiTimeline', { newPosts: undefined, numPosts: _this2.searchEraiPostsNum });

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    infiniteTsuraiHandler: function infiniteTsuraiHandler(state) {
      var _this3 = this;

      var preLength = this.$store.state.postsTsurai.length;
      this.showMore(0).then(function () {
        if (preLength !== _this3.$store.state.postsTsurai.length) {
          state.loaded();
        } else {
          state.complete();
        }
      }).catch(function (e) {
        return console.error(e);
      });
    },
    infiniteEraiHandler: function infiniteEraiHandler(state) {
      var _this4 = this;

      var preLength = this.$store.state.postsErai.length;
      this.showMore(1).then(function () {
        if (preLength !== _this4.$store.state.postsErai.length) {
          state.loaded();
        } else {
          state.complete();
        }
      }).catch(function (e) {
        return alert('データを正常に読み込めませんでした');
      });
    },
    editProfile: function editProfile() {
      this.isEditing = true;
    },
    completeEdit: function completeEdit() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var twitterPattern, regMatch, resultURL;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this5.visitedUserInfo.username) {
                  _context3.next = 3;
                  break;
                }

                alert('ユーザーネームを入力してください');
                return _context3.abrupt('return');

              case 3:
                if (!(_this5.visitedUserInfo.username.length > 10)) {
                  _context3.next = 6;
                  break;
                }

                alert('ユーザーネームは10文字以下にしてください');
                return _context3.abrupt('return');

              case 6:
                if (!(_this5.visitingUserInfo.twitter.length > 30)) {
                  _context3.next = 9;
                  break;
                }

                alert('Twitter IDが長すぎます');
                return _context3.abrupt('return');

              case 9:
                twitterPattern = /^@[a-zA-Z0-9_]+$/;
                regMatch = _this5.visitedUserInfo.twitter.match(twitterPattern);

                if (!(!!_this5.visitedUserInfo.twitter && regMatch === null)) {
                  _context3.next = 14;
                  break;
                }

                alert('Twiiter IDは1文字目が@でかつ半角英数字とアンダーバーのみしか入力できません');
                return _context3.abrupt('return');

              case 14:
                _this5.visitedUserInfo.twitter = !_this5.visitedUserInfo.twitter ? '' : regMatch[0];
                if (!_this5.visitedUserInfo.bio) {
                  _this5.visitedUserInfo.bio = '';
                }

                if (!(_this5.visitedUserInfo.bio > 100)) {
                  _context3.next = 19;
                  break;
                }

                alert('自己紹介は100文字以下にしてください');
                return _context3.abrupt('return');

              case 19:
                if (!_this5.visitedUserInfo.bio) {
                  _this5.visitedUserInfo.bio = '';
                }
                _context3.prev = 20;
                _context3.next = 23;
                return _this5.$refs.ImageUploadForm.uploadCroppedImage();

              case 23:
                resultURL = _context3.sent;

                _this5.visitedUserInfo.icon_URL = resultURL;
                _context3.next = 27;
                return db.collection('users').doc(_this5.visitedUserInfo.user_id).update({
                  username: _this5.visitedUserInfo.username,
                  twitter: _this5.visitedUserInfo.twitter,
                  bio: _this5.visitedUserInfo.bio
                });

              case 27:
                _context3.next = 33;
                break;

              case 29:
                _context3.prev = 29;
                _context3.t0 = _context3['catch'](20);

                alert('エラー：' + _context3.t0);
                return _context3.abrupt('return');

              case 33:
                _this5.$store.dispatch('getVisitedUserInfoState', _this5.visitedUserID);
                alert('プロフィールが正常に更新されました');
                _this5.isEditing = false;

              case 36:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[20, 29]]);
      }))();
    }
  },
  watch: {
    visitedUserID: function visitedUserID(newId, oldId) {
      this.$store.dispatch('getVisitedUserInfoState', newId);
    }
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);



//
//
//
//
//
//
//
//
//
//
//
//


var db = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      iconCroppa: {},
      fontSize: 14,
      maxFileSize: 1024 * 1024 * 5
    };
  },

  props: {
    userId: {
      type: String,
      required: true
    }
  },
  methods: {
    uploadCroppedImage: function uploadCroppedImage() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var blob, fileName, newFile, storageRef, snapshot, downloadURL;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return _this.iconCroppa.generateBlob(resolve);
                });

              case 2:
                blob = _context.sent;

                if (blob) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                fileName = _this.userId + '.' + blob.type.split('/')[1];
                newFile = new File([blob], fileName, { type: blob.type });
                storageRef = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.storage().ref().child('/icons/' + newFile.name);
                _context.prev = 8;
                _context.next = 11;
                return storageRef.put(newFile);

              case 11:
                snapshot = _context.sent;
                _context.next = 14;
                return snapshot.ref.getDownloadURL();

              case 14:
                downloadURL = _context.sent;
                _context.next = 17;
                return db.collection('users').doc(_this.userId).update({
                  'icon_URL': downloadURL
                });

              case 17:
                return _context.abrupt('return', downloadURL);

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](8);

                alert('画像をアップロードできませんでした');

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[8, 20]]);
      }))();
    }
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(51);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'common-header': __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  created: function created() {
    this.$store.dispatch('getLoginState');
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.state.isLoggedIn;
    }
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var db = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.firestore();

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      reportText: '',
      isProcessing: false
    };
  },

  components: {
    'common-header': __WEBPACK_IMPORTED_MODULE_0__components_Header__["a" /* default */]
  },
  created: function created() {
    this.$store.dispatch('getLoginState');
    this.$store.dispatch('getUserInfoState');
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.state.isLoggedIn;
    }
  },
  methods: {
    report: function report() {
      var _this = this;

      this.isProcessing = true;
      db.collection('reports').doc().set({
        username: this.$store.state.userInfo.username,
        user_id: this.$store.state.userInfo.user_id,
        content: this.reportText
      }).then(function () {
        alert('正常に送信できました。ご協力ありがとうございます。');
        _this.reportText = '';
        _this.isProcessing = false;
      });
    }
  }
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_croppa__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_croppa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_croppa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_sync__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons_pencil_alt__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_lazyload__ = __webpack_require__(585);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_lazyload__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_croppa___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router_js__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76e5fa27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(445);
function injectStyle (ssrContext) {
  __webpack_require__(361)
  __webpack_require__(363)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76e5fa27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76e5fa27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 361:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dev = {
  apiKey: "AIzaSyBEWPVwn1IK4E-hgkjPV4TaQoD6SSNCw3Y",
  authDomain: "tsuratsura-0000.firebaseapp.com",
  databaseURL: "https://tsuratsura-0000.firebaseio.com",
  projectId: "tsuratsura-0000",
  storageBucket: "tsuratsura-0000.appspot.com",
  messagingSenderId: "277474484818"
};

var prod = {
  apiKey: "AIzaSyDX_Sz9Pw2yvipzgpmPCRzaK7mXBb8t9EY",
  authDomain: "sorehatsurai.firebaseapp.com",
  databaseURL: "https://sorehatsurai.firebaseio.com",
  projectId: "sorehatsurai",
  storageBucket: "sorehatsurai.appspot.com",
  messagingSenderId: "459637759024",
  appId: "1:459637759024:web:c99c29d0bead28dc"
};

var config = prod;

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Signup__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Signin__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_UserPage__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_About__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Contact__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    redirect: '/signin'
  }, {
    path: '/timeline',
    redirect: '/timeline/tsurai'
  }, {
    path: '/timeline/:mode',
    name: 'Timeline',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_home__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_About__["a" /* default */]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Contact__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Signup__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Signin',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Signin__["a" /* default */]
  }, {
    path: '/user/:id',
    name: 'UserPage',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_UserPage__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });
  if (requiresAuth) {
    __WEBPACK_IMPORTED_MODULE_8_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {
        next();
      } else {
        next({
          path: '/signin',
          query: { redirect: to.fullPath }
        });
      }
    });
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1f5e62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(523);
function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c1f5e62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1f5e62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostSubmitForm_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a800d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostSubmitForm_vue__ = __webpack_require__(481);
function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28a800d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostSubmitForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28a800d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostSubmitForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-post-form"},[_c('div',{class:{'is-open': _vm.showModal, 'p-modal': !_vm.showModal}},[_c('form',{staticClass:"margin-top",on:{"submit":function($event){$event.preventDefault();return _vm.sendPost($event)}}},[_c('fieldset',[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-4 offset-md-4"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"form-control form-margin",class:_vm.postFormStyle,attrs:{"rows":"5","id":"inputText","placeholder":_vm.placeholderMassage},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 col-mdhhoffset-2"},[_c('button',{staticClass:"btn center-block",class:_vm.postButtonStyle,attrs:{"disabled":_vm.isProcessing,"type":"submit"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("投稿")])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger center-block",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("閉じる")])]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticClass:"form-horizontal",attrs:{"id":"post"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.sendPost($event)}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"form-control",class:_vm.postFormStyle,attrs:{"rows":"6","id":"inputText","placeholder":_vm.placeholderMassage},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12 col-mdhhoffset-2"},[_c('button',{staticClass:"btn center-block",class:_vm.postButtonStyle,attrs:{"disabled":_vm.isProcessing,"type":"submit"}},[_vm._v("投稿")])])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TooBad_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab64f4aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TooBad_vue__ = __webpack_require__(495);
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TooBad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab64f4aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TooBad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 20 20","aria-labelledby":"too_bad","role":"presentation"}},[_c('title',[_vm._v("too_bad")]),_vm._v(" "),_c('g',{attrs:{"fill":_vm.iconColor}},[_c('g',{attrs:{"id":"layer_2","data-name":"layer 2"}},[_c('g',{attrs:{"id":"layer_1-2","data-name":"layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0ZM6.25,5.736a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,6.25,5.736ZM5.125,13a1.463,1.463,0,1,1-2.713-1.095,4.459,4.459,0,0,1,1.109-1.347A12.722,12.722,0,0,1,4.962,9.5a14.124,14.124,0,0,1,.314,1.788A3.992,3.992,0,0,1,5.125,13Zm9.217,3.014a.66.66,0,0,1-.176.023A.523.523,0,0,1,13.7,15.8c-.256-.5-1.131-1.647-3.7-1.647S6.558,15.309,6.3,15.8a.568.568,0,0,1-.644.211c-.257-.07-.389-.278-.292-.465.687-1.325,2.42-2.116,4.635-2.116s3.948.791,4.634,2.116C14.732,15.737,14.6,15.945,14.342,16.015ZM13.75,8.736a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,13.75,8.736Z"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllRight_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c708fa24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllRight_vue__ = __webpack_require__(497);
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllRight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c708fa24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllRight_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 20 19.013","aria-labelledby":"all_right","role":"presentation"}},[_c('title',[_vm._v("all_right")]),_vm._v(" "),_c('g',{attrs:{"fill":_vm.iconColor}},[_c('g',{attrs:{"id":"layer_2","data-name":"layer 2"}},[_c('g',{attrs:{"id":"layer_1-2","data-name":"layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M4.991,10.694a.92.92,0,0,0,0,1.3l1.392,1.391a.279.279,0,0,1,0,.393l-.657.656H5.4L2.275,11.311a.281.281,0,0,1-.082-.2V6.785a.918.918,0,0,0-.918-.918H.918A.918.918,0,0,0,0,6.785V13.7a.571.571,0,0,0,.167.4l3.648,3.646a1.057,1.057,0,0,1,.308.745v.261a.253.253,0,0,0,.253.253H8.9a.252.252,0,0,0,.252-.253V13.488L6.29,10.694A.92.92,0,0,0,4.991,10.694Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M19.082,5.867h-.357a.918.918,0,0,0-.918.918v4.329a.281.281,0,0,1-.082.2L14.6,14.433h-.328l-.657-.656a.279.279,0,0,1,0-.393l1.392-1.391a.919.919,0,0,0-1.3-1.3l-2.862,2.794V18.76a.252.252,0,0,0,.252.253h4.524a.253.253,0,0,0,.253-.253V18.5a1.057,1.057,0,0,1,.308-.745l3.648-3.646A.571.571,0,0,0,20,13.7V6.785A.918.918,0,0,0,19.082,5.867Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M14.362.8a2.719,2.719,0,0,0-3.844,0l-.417.417a.142.142,0,0,1-.2,0L9.482.8A2.718,2.718,0,0,0,5.638,4.64L9.784,8.786a.306.306,0,0,0,.432,0L14.362,4.64A2.719,2.719,0,0,0,14.362.8Z"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Congrat_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a555a1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Congrat_vue__ = __webpack_require__(499);
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Congrat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a555a1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Congrat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 19.86 20.067","aria-labelledby":"congrat","role":"presentation"}},[_c('title',[_vm._v("congrat")]),_vm._v(" "),_c('g',{attrs:{"fill":_vm.iconColor}},[_c('g',{attrs:{"id":"layer_2","data-name":"layer 2"}},[_c('g',{attrs:{"id":"layer_1-2","data-name":"layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M13.36,7.875l.707.707a3.6,3.6,0,0,1,5.086,0l.707-.707A4.6,4.6,0,0,0,13.36,7.875Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M12.344,5.453a3.859,3.859,0,0,0,0-5.453l-.707.707a2.86,2.86,0,0,1,0,4.039Z"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"8.828","y":"0.964","width":"1","height":"1.587","transform":"translate(-0.16 2.039) rotate(-12.368)"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"15.886","y":"4.01","width":"3.047","height":"1","transform":"translate(-0.504 2.918) rotate(-9.444)"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"16.659","y":"10.982","width":"0.999","height":"0.826","transform":"translate(1.91 25.242) rotate(-75.832)"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M.112,17.274A.9.9,0,0,0,.23,18.31l1.3,1.458A.9.9,0,0,0,2.55,20l4.918-2.042L1.313,15.1Z"}}),_c('polygon',{staticClass:"cls-1",attrs:{"points":"1.797 14.221 8.721 17.437 14.002 15.244 3.837 10.524 1.797 14.221"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M8.52,4.517a.887.887,0,0,0-.773-.295.9.9,0,0,0-.686.46L4.321,9.646l10.934,5.078.579-.241a.9.9,0,0,0,.325-1.43Z"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Great_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d50d5f9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Great_vue__ = __webpack_require__(501);
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Great_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d50d5f9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Great_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 20 20","aria-labelledby":"great","role":"presentation"}},[_c('title',[_vm._v("great")]),_vm._v(" "),_c('g',{attrs:{"fill":_vm.iconColor}},[_c('g',{attrs:{"id":"layer_2","data-name":"layer 2"}},[_c('g',{attrs:{"id":"layer_1-2","data-name":"layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm3.75,5.167a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,13.75,5.167Zm-7.5,0a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,6.25,5.167ZM10,16.667a5.665,5.665,0,0,1-5.649-5.243A.4.4,0,0,1,4.756,11s3.144.36,5.244.36S15.244,11,15.244,11a.4.4,0,0,1,.4.422A5.665,5.665,0,0,1,10,16.667Z"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoodJob_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7be2041a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoodJob_vue__ = __webpack_require__(503);
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoodJob_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7be2041a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoodJob_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 19.608 20.801","aria-labelledby":"good_job","role":"presentation"}},[_c('title',[_vm._v("good_job")]),_vm._v(" "),_c('g',{attrs:{"fill":_vm.iconColor}},[_c('g',{attrs:{"id":"layer_2","data-name":"layer 2"}},[_c('g',{attrs:{"id":"layer_1-2","data-name":"layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M19.17,9.247l-.435-.283a.961.961,0,0,0-1.33.282l-.569.875V3.071a.962.962,0,1,0-1.923,0v4.18h-.422V2.639a.962.962,0,0,0-.962-.961h-.2a.961.961,0,0,0-.961.961V7.251h-.422V3.086a.962.962,0,0,0-.962-.962h-.2a.962.962,0,0,0-.961.962v3.2a1.453,1.453,0,0,1,.293.33L13.051,11.3a1.47,1.47,0,0,1,.349-.523,1.4,1.4,0,0,1,1.039-.41l.521.009A1.462,1.462,0,0,1,16.4,11.866l-.047,2.746h.488V14.6l2.617-4.027A.962.962,0,0,0,19.17,9.247Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M8.106,6.152a1.456,1.456,0,0,1,1.3-.119V3.986a.962.962,0,0,0-.962-.962H8.322a.962.962,0,0,0-.962.962V7c.034.018.071.027.1.048A1.457,1.457,0,0,1,8.106,6.152Z"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"2.125","y":"1.267","width":"1.214","height":"2.509","transform":"translate(-0.842 1.499) rotate(-26.739)"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"0.783","y":"3.71","width":"1.214","height":"2.509","transform":"translate(-3.604 3.686) rotate(-60)"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"4.447","width":"1.214","height":"2.509"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M14.881,10.788l-.519-.009a.962.962,0,0,0-.978.945l-.018,1.044L9.627,6.791A.961.961,0,1,0,8,7.81l2.217,3.545-.358.223L7.41,7.669a.962.962,0,0,0-1.325-.306l-.168.1a.961.961,0,0,0-.3,1.325L8.058,12.7l-.358.224L5.491,9.4A.962.962,0,0,0,4.166,9.09L4,9.2a.962.962,0,0,0-.305,1.326L5.9,14.052l-.358.224L3.812,11.507a.962.962,0,0,0-1.325-.3l-.1.065a.961.961,0,0,0-.306,1.325l4.374,6.991a.7.7,0,0,0,.319.273l2.221.945,6.755-4.226,0-.007.083-4.8A.962.962,0,0,0,14.881,10.788Z"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Genius_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9af5426_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Genius_vue__ = __webpack_require__(505);
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Genius_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9af5426_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Genius_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 20.288 14.153","aria-labelledby":"genius","role":"presentation"}},[_c('title',[_vm._v("genius")]),_vm._v(" "),_c('g',{attrs:{"fill":_vm.iconColor}},[_c('g',{attrs:{"id":"layer_2","data-name":"layer 2"}},[_c('g',{attrs:{"id":"layer_1-2","data-name":"layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M9.272,13.959a8.862,8.862,0,0,1-4.03-5.225c-1.279,4.028-3.34,5.015-4.223,5.419L0,12.422a5.042,5.042,0,0,0,2.955-2.151,8.694,8.694,0,0,0,1.3-3.494H1.121V4.966H4.382V2.442H.419V.647h9.635v1.8H5.865c0,1.44-.011,1.893-.011,2.524H9.363V6.777H6.023a9.015,9.015,0,0,0,1.9,3.818,6.684,6.684,0,0,0,2.377,1.7Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M18.261,4.707l.589.744A.7.7,0,0,1,19,5.742a.121.121,0,0,1-.125.13c-.237.016-.26.032-.328.113a12.7,12.7,0,0,1-1.982,2.426l.1,3.882c.045,1.763-1.6,1.828-2.321,1.86l-.8-2.215a4,4,0,0,0,.939.145c.272,0,.725,0,.713-.776l-.033-1.634a20.684,20.684,0,0,1-3.793,2.474l-.906-1.666A12.1,12.1,0,0,0,15.113,7.7l-.067-2.992H10.573V2.9h4.439L14.943,0l1.393.389c.068.015.329.1.329.291,0,.064-.034.113-.147.226-.136.129-.136.195-.136.242L16.427,2.9h3.861V4.707Zm-1.789,0,.034,1.5a7.741,7.741,0,0,0,.985-1.5Z"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp-layout"},[_c('span',{staticClass:"stamp",on:{"click":function($event){return _vm.click()}}},[_c(_vm.stampComponent,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"icon-color":_vm.stampColor}})],1),_vm._v(" "),_c('br'),_c('span',{style:(_vm.stampCounter)},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg-inline--fa fa-twitter fa-w-16",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fab","data-icon":"twitter","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","width":"20","height":"20"}},[_c('title',[_vm._v("twitter")]),_vm._v(" "),_c('path',{attrs:{"fill":"#55acee","d":"M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card p-2 mb-2 tsurai-card-color"},[_c('div',{staticClass:"card-header tsurai-card-header"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.iconURL),expression:"iconURL"}],attrs:{"width":"40px","height":"40px"}})]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('router-link',{staticClass:"tsurai-username",attrs:{"to":{name: 'UserPage', params: {id: _vm.author_auth_id}}}},[_vm._v("\n                       "+_vm._s(_vm.post.author.username)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"tsurai-datetime"},[_c('span',[_vm._v(_vm._s(_vm.formattedCreatedTime))])])],1),_vm._v(" "),_c('div',{staticClass:"content delete-button"},[(_vm.isAuthor)?_c('span',{on:{"click":_vm.deletePost}},[_c('small',[_vm._v("削除")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-right stamp-box"},[_c('stamp',{attrs:{"kind":"too-bad","active":_vm.isActive('too-bad'),"count":_vm.num_that_is_too_bad},on:{"click":_vm.toggle_too_bad}}),_vm._v(" "),_c('stamp',{attrs:{"kind":"alright","active":_vm.isActive('alright'),"count":_vm.num_you_are_alright},on:{"click":_vm.toggle_alright}}),_vm._v(" "),_c('stamp',{attrs:{"kind":"good-job","active":_vm.isActive('good-job'),"count":_vm.num_good_job},on:{"click":_vm.toggle_good_job}})],1)])]),_vm._v(" "),_c('div',{staticClass:"card-body text-left show-newline border-line"},[_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.post.posts.body))])]),_vm._v(" "),(_vm.isAuthor)?_c('div',{staticClass:"card-footer"},[_c('a',{attrs:{"href":_vm.twiUrl,"target":"_blank"}},[_c('twitter-icon')],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004fa65e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(516);
function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-004fa65e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004fa65e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card p-2 mb-2 erai-card-color"},[_c('div',{staticClass:"card-header erai-card-header"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.iconURL),expression:"iconURL"}],attrs:{"width":"40px","height":"40px"}})]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('router-link',{staticClass:"erai-username",attrs:{"to":{name: 'UserPage', params: {id: _vm.author_auth_id}}}},[_vm._v("\n                       "+_vm._s(_vm.post.author.username)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"erai-datetime"},[_c('span',[_vm._v(_vm._s(_vm.formattedCreatedTime))])])],1),_vm._v(" "),_c('div',{staticClass:"content delete-button"},[(_vm.isAuthor)?_c('span',{on:{"click":_vm.deletePost}},[_c('small',[_vm._v("削除")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"float-right stamp-box"},[_c('stamp',{attrs:{"kind":"great","active":_vm.isActive('great'),"count":_vm.num_great},on:{"click":_vm.toggle_great}}),_vm._v(" "),_c('stamp',{attrs:{"kind":"congrat","active":_vm.isActive('congrat'),"count":_vm.num_congrat},on:{"click":_vm.toggle_congrat}}),_vm._v(" "),_c('stamp',{attrs:{"kind":"genius","active":_vm.isActive('genius'),"count":_vm.num_genius},on:{"click":_vm.toggle_genius}})],1)])]),_vm._v(" "),_c('div',{staticClass:"card-body text-left show-newline border-line"},[_c('span',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.post.posts.body))])]),_vm._v(" "),(_vm.isAuthor)?_c('div',{staticClass:"card-footer"},[_c('a',{attrs:{"href":_vm.twiUrl,"target":"_blank"}},[_c('twitter-icon')],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff314c9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_whiteLogo_vue__ = __webpack_require__(513);
var normalizeComponent = __webpack_require__(9)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ff314c9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_whiteLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1005.484 139.619","width":"200"}},[_c('defs'),_vm._v(" "),_c('title',[_vm._v("ロゴ")]),_vm._v(" "),_c('g',{attrs:{"fill":"white","id":"layer_2","data-name":"layer 2"}},[_c('g',{attrs:{"id":"layer_2-2","data-name":"layer 2"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M130.945,21.746a291.393,291.393,0,0,1-127.5,0A4.152,4.152,0,0,1,.1,16.864Q1.759,9.97,3.414,3.075A4.084,4.084,0,0,1,8.3.1a269.2,269.2,0,0,0,117.8,0,4.084,4.084,0,0,1,4.883,2.973q1.656,6.894,3.311,13.789A4.152,4.152,0,0,1,130.945,21.746Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M643.957,129.94a225.563,225.563,0,0,1-130.731,0,4.22,4.22,0,0,1-3.1-5.165l4.382-13.487a4.126,4.126,0,0,1,5.145-2.577,203.38,203.38,0,0,0,117.875,0,4.126,4.126,0,0,1,5.145,2.577l4.383,13.487A4.224,4.224,0,0,1,643.957,129.94Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M188.98,87.866a31.7,31.7,0,0,1,11.68,2.96,18.576,18.576,0,0,1,10.16,12.639,32.091,32.091,0,0,1,.88,7.281v2.24q0,11.361-8.16,17.68t-25.12,6.32q-7.2,0-16.72-.08-7.717-.068-15.485-.183a3.008,3.008,0,0,1-2.9-3.612l1.641-7.931a2.989,2.989,0,0,1,2.98-2.39q7.444.127,15.124.2,8.959.082,16.161.08,9.274,0,12.718-2.08t3.441-8.16a15.6,15.6,0,0,0-.4-3.6,6.465,6.465,0,0,0-1.6-2.96,9.329,9.329,0,0,0-3.441-2.159,22.272,22.272,0,0,0-6.08-1.2l-19.2-1.76a28.485,28.485,0,0,1-10.08-2.48,20.37,20.37,0,0,1-6.721-4.96,19.112,19.112,0,0,1-3.76-6.64,24.138,24.138,0,0,1-1.2-7.521V76.826q0-10.88,7.52-17.04t24.64-6.16h16q6.855,0,15.126.217a3.006,3.006,0,0,1,2.868,3.608l-1.647,7.966a3.007,3.007,0,0,1-3.012,2.391q-5.192-.116-9.335-.182-5.124-.08-9.041-.081H173.3q-8.161,0-11.361,2t-3.2,7.121a15.2,15.2,0,0,0,.4,3.679,5.418,5.418,0,0,0,1.6,2.721,9.822,9.822,0,0,0,3.52,1.92,25.971,25.971,0,0,0,6.16,1.12Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M271.059,139.225q-18.083,0-27.2-6.079t-9.12-20.8v-55.4a3,3,0,0,1,3-3h10.8a3,3,0,0,1,3,3v52.04a45.6,45.6,0,0,0,.48,7.04,9.549,9.549,0,0,0,2.4,5.12,11.884,11.884,0,0,0,5.84,3.119,43.881,43.881,0,0,0,10.8,1.04,42.9,42.9,0,0,0,10.72-1.04,11.843,11.843,0,0,0,5.76-3.119,9.548,9.548,0,0,0,2.4-5.12,45.468,45.468,0,0,0,.481-7.04V56.946a3,3,0,0,1,3-3h10.8a3,3,0,0,1,3,3v55.4q0,14.724-9.12,20.8T271.059,139.225Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M335.177,136.666a3,3,0,0,1-3-3V80.026a30.018,30.018,0,0,1,2.24-12.24,20.568,20.568,0,0,1,6.319-8.16,26.6,26.6,0,0,1,9.841-4.56,52.786,52.786,0,0,1,12.8-1.44h11.84q1.766,0,3.272.029a3,3,0,0,1,2.889,3.608l-1.662,8.028a2.984,2.984,0,0,1-2.958,2.385c-3.781-.047-10.7-.131-11.782-.131a29.541,29.541,0,0,0-8.8,1.041,9.576,9.576,0,0,0-4.8,3.12,10.439,10.439,0,0,0-2,5.12,52.916,52.916,0,0,0-.4,6.88v49.96a3,3,0,0,1-3,3Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M469.176,122.906q0,7.68-3.52,10.72t-12.8,3.04h-24q-16.8,0-24.08-6.161T397.5,112.026v-3.521q0-13.44,7.92-19.2t24.72-5.76q9.6,0,15.04,1.521,2.226.624,3.971,1.286a2.981,2.981,0,0,0,4.029-2.8v-.006a37.912,37.912,0,0,0-.561-6.959,8.825,8.825,0,0,0-2.72-4.96,14.263,14.263,0,0,0-6.239-3.04,46.99,46.99,0,0,0-11.121-1.041q-6.719,0-14.319.081-5.106.054-9.236.144a3,3,0,0,1-2.989-3.639l1.726-7.9a3,3,0,0,1,2.841-2.359q3.759-.105,8.7-.166,6.56-.08,13.279-.08,19.359,0,28,6.8t8.641,20.08Zm-56-11.04q0,5.6,3.359,8.4t12.32,2.8h16.321a8,8,0,0,0,8-8v-6.721a19.37,19.37,0,0,0-.641-5.279,6.481,6.481,0,0,0-2.56-3.6,13.934,13.934,0,0,0-5.6-2,59.674,59.674,0,0,0-9.76-.639h-3.68a56.061,56.061,0,0,0-8.719.559,13.584,13.584,0,0,0-5.441,1.92,7.181,7.181,0,0,0-2.8,3.6,16.812,16.812,0,0,0-.8,5.6Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M725.289,87.866a31.706,31.706,0,0,1,11.68,2.96,18.583,18.583,0,0,1,10.16,12.639,32.091,32.091,0,0,1,.88,7.281v2.24q0,11.361-8.161,17.68t-25.12,6.32q-7.2,0-16.719-.08-7.719-.068-15.486-.183a3.007,3.007,0,0,1-2.9-3.612l1.641-7.931a2.988,2.988,0,0,1,2.98-2.39q7.444.127,15.124.2,8.959.082,16.16.08,9.276,0,12.719-2.08t3.44-8.16a15.606,15.606,0,0,0-.4-3.6,6.476,6.476,0,0,0-1.6-2.96,9.324,9.324,0,0,0-3.44-2.159,22.28,22.28,0,0,0-6.08-1.2l-19.2-1.76a28.49,28.49,0,0,1-10.081-2.48,20.365,20.365,0,0,1-6.72-4.96,19.112,19.112,0,0,1-3.76-6.64,24.109,24.109,0,0,1-1.2-7.521V76.826q0-10.88,7.519-17.04t24.641-6.16h16q6.855,0,15.126.217a3.007,3.007,0,0,1,2.868,3.608l-1.648,7.966a3.006,3.006,0,0,1-3.012,2.391q-5.192-.116-9.334-.182-5.124-.08-9.041-.081h-12.72q-8.16,0-11.36,2t-3.2,7.121a15.153,15.153,0,0,0,.4,3.679,5.418,5.418,0,0,0,1.6,2.721,9.808,9.808,0,0,0,3.519,1.92,25.981,25.981,0,0,0,6.16,1.12Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M807.368,139.225q-18.084,0-27.2-6.079t-9.12-20.8v-55.4a3,3,0,0,1,3-3h10.8a3,3,0,0,1,3,3v52.04a45.592,45.592,0,0,0,.481,7.04,9.548,9.548,0,0,0,2.4,5.12,11.893,11.893,0,0,0,5.84,3.119,43.89,43.89,0,0,0,10.8,1.04,42.907,42.907,0,0,0,10.72-1.04,11.844,11.844,0,0,0,5.759-3.119,9.542,9.542,0,0,0,2.4-5.12,45.6,45.6,0,0,0,.48-7.04V56.946a3,3,0,0,1,3-3h10.8a3,3,0,0,1,3,3v55.4q0,14.724-9.119,20.8T807.368,139.225Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M871.485,136.666a3,3,0,0,1-3-3V80.026a30.018,30.018,0,0,1,2.24-12.24,20.579,20.579,0,0,1,6.32-8.16,26.588,26.588,0,0,1,9.841-4.56,52.778,52.778,0,0,1,12.8-1.44h11.84q1.766,0,3.272.029a3,3,0,0,1,2.889,3.608l-1.661,8.028a2.984,2.984,0,0,1-2.958,2.385c-3.782-.047-10.7-.131-11.782-.131a29.553,29.553,0,0,0-8.8,1.041,9.58,9.58,0,0,0-4.8,3.12,10.458,10.458,0,0,0-2,5.12,53.105,53.105,0,0,0-.4,6.88v49.96a3,3,0,0,1-3,3Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M1005.484,122.906q0,7.68-3.519,10.72t-12.8,3.04h-24q-16.8,0-24.08-6.161t-7.279-18.479v-3.521q0-13.44,7.919-19.2t24.72-5.76q9.6,0,15.04,1.521,2.228.624,3.972,1.286a2.981,2.981,0,0,0,4.028-2.8v-.006a37.92,37.92,0,0,0-.56-6.959,8.83,8.83,0,0,0-2.72-4.96,14.269,14.269,0,0,0-6.239-3.04,46.99,46.99,0,0,0-11.121-1.041q-6.72,0-14.32.081-5.1.054-9.235.144a3,3,0,0,1-2.989-3.639l1.725-7.9a3,3,0,0,1,2.842-2.359q3.757-.105,8.7-.166,6.56-.08,13.28-.08,19.359,0,28,6.8t8.64,20.08Zm-56-11.04q0,5.6,3.36,8.4t12.32,2.8h16.32a8,8,0,0,0,8-8v-6.721a19.412,19.412,0,0,0-.64-5.279,6.486,6.486,0,0,0-2.56-3.6,13.934,13.934,0,0,0-5.6-2,59.669,59.669,0,0,0-9.759-.639h-3.68a56.066,56.066,0,0,0-8.72.559,13.579,13.579,0,0,0-5.44,1.92,7.176,7.176,0,0,0-2.8,3.6,16.809,16.809,0,0,0-.8,5.6Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M88.2,108.928c0,15.986-9.4,28.945-21,28.945s-21-12.959-21-28.945c0-7.119,2.917-20.375,7.537-32.932A279.769,279.769,0,0,1,67.195,45.817,308.293,308.293,0,0,1,80.984,76.294C85.9,89.437,88.2,101.415,88.2,108.928Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M599.592,31.527c0-15.986-9.4-28.945-21-28.945s-21,12.959-21,28.945c0,7.119,2.917,20.375,7.537,32.932a279.769,279.769,0,0,0,13.463,30.179,308.293,308.293,0,0,0,13.789-30.477C597.3,51.017,599.592,39.039,599.592,31.527Z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e3e8d8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blackLogo_vue__ = __webpack_require__(515);
var normalizeComponent = __webpack_require__(9)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e3e8d8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blackLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1005.484 139.618","width":"200"}},[_c('title',[_vm._v("ロゴ")]),_vm._v(" "),_c('g',{attrs:{"id":"layer_2","data-name":"layer 2"}},[_c('g',{attrs:{"id":"layer_2-2","data-name":"layer 2"}},[_c('path',{attrs:{"d":"M130.945,21.745a291.378,291.378,0,0,1-127.5,0A4.15,4.15,0,0,1,.1,16.864q1.655-6.9,3.31-13.79A4.086,4.086,0,0,1,8.3.1a269.231,269.231,0,0,0,117.8,0,4.084,4.084,0,0,1,4.883,2.972q1.656,6.894,3.311,13.79A4.151,4.151,0,0,1,130.945,21.745Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M643.957,129.94a225.563,225.563,0,0,1-130.731,0,4.223,4.223,0,0,1-3.1-5.166q2.192-6.743,4.382-13.487a4.127,4.127,0,0,1,5.145-2.577,203.38,203.38,0,0,0,117.875,0,4.126,4.126,0,0,1,5.145,2.577l4.383,13.487A4.223,4.223,0,0,1,643.957,129.94Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M188.98,87.865a31.7,31.7,0,0,1,11.68,2.96,18.58,18.58,0,0,1,10.16,12.64,32.082,32.082,0,0,1,.88,7.28v2.24q0,11.362-8.16,17.68t-25.12,6.32q-7.2,0-16.72-.08-7.717-.067-15.485-.183a3.008,3.008,0,0,1-2.9-3.612l1.641-7.931a2.988,2.988,0,0,1,2.98-2.389q7.444.127,15.124.195,8.959.083,16.161.08,9.274,0,12.718-2.08t3.441-8.16a15.6,15.6,0,0,0-.4-3.6,6.469,6.469,0,0,0-1.6-2.96,9.3,9.3,0,0,0-3.441-2.159,22.268,22.268,0,0,0-6.08-1.2l-19.2-1.759a28.506,28.506,0,0,1-10.08-2.481,20.346,20.346,0,0,1-6.721-4.96,19.1,19.1,0,0,1-3.76-6.64,24.132,24.132,0,0,1-1.2-7.52v-2.72q0-10.879,7.52-17.04t24.64-6.16h16q6.855,0,15.126.218a3.006,3.006,0,0,1,2.868,3.608l-1.647,7.965a3.009,3.009,0,0,1-3.012,2.392q-5.192-.117-9.335-.183-5.124-.079-9.041-.08H173.3q-8.161,0-11.361,2t-3.2,7.12a15.211,15.211,0,0,0,.4,3.68,5.419,5.419,0,0,0,1.6,2.72,9.807,9.807,0,0,0,3.52,1.92,25.9,25.9,0,0,0,6.16,1.121Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M271.059,139.225q-18.083,0-27.2-6.079t-9.12-20.8v-55.4a3,3,0,0,1,3-3h10.8a3,3,0,0,1,3,3v52.04a45.6,45.6,0,0,0,.48,7.04,9.549,9.549,0,0,0,2.4,5.121,11.9,11.9,0,0,0,5.84,3.119,43.93,43.93,0,0,0,10.8,1.04,42.949,42.949,0,0,0,10.72-1.04,11.859,11.859,0,0,0,5.76-3.119,9.548,9.548,0,0,0,2.4-5.121,45.468,45.468,0,0,0,.481-7.04V56.945a3,3,0,0,1,3-3h10.8a3,3,0,0,1,3,3v55.4q0,14.722-9.12,20.8T271.059,139.225Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M335.177,136.665a3,3,0,0,1-3-3V80.025a30.025,30.025,0,0,1,2.24-12.24,20.575,20.575,0,0,1,6.319-8.16,26.611,26.611,0,0,1,9.841-4.56,52.836,52.836,0,0,1,12.8-1.44h11.84q1.766,0,3.272.029a3,3,0,0,1,2.889,3.608l-1.662,8.028a2.982,2.982,0,0,1-2.958,2.385c-3.781-.046-10.7-.13-11.782-.13a29.579,29.579,0,0,0-8.8,1.04,9.576,9.576,0,0,0-4.8,3.12,10.447,10.447,0,0,0-2,5.12,52.938,52.938,0,0,0-.4,6.88v49.96a3,3,0,0,1-3,3Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M469.176,122.905q0,7.68-3.52,10.72t-12.8,3.04h-24q-16.8,0-24.08-6.16t-7.279-18.48v-3.52q0-13.44,7.92-19.2t24.72-5.76q9.6,0,15.04,1.52,2.226.624,3.971,1.286a2.98,2.98,0,0,0,4.029-2.8v-.006a37.932,37.932,0,0,0-.561-6.96,8.825,8.825,0,0,0-2.72-4.96,14.263,14.263,0,0,0-6.239-3.04,47.051,47.051,0,0,0-11.121-1.04q-6.719,0-14.319.08-5.106.056-9.236.145a3,3,0,0,1-2.989-3.64l1.726-7.9a3,3,0,0,1,2.841-2.358q3.759-.105,8.7-.167,6.56-.079,13.279-.08,19.359,0,28,6.8t8.641,20.08Zm-56-11.04q0,5.6,3.359,8.4t12.32,2.8h16.321a8,8,0,0,0,8-8v-6.72a19.377,19.377,0,0,0-.641-5.28,6.475,6.475,0,0,0-2.56-3.6,13.934,13.934,0,0,0-5.6-2,59.544,59.544,0,0,0-9.76-.64h-3.68a56.045,56.045,0,0,0-8.719.56,13.569,13.569,0,0,0-5.441,1.92,7.179,7.179,0,0,0-2.8,3.6,16.818,16.818,0,0,0-.8,5.6Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M725.289,87.865a31.706,31.706,0,0,1,11.68,2.96,18.588,18.588,0,0,1,10.16,12.64,32.082,32.082,0,0,1,.88,7.28v2.24q0,11.362-8.161,17.68t-25.12,6.32q-7.2,0-16.719-.08-7.719-.067-15.486-.183a3.007,3.007,0,0,1-2.9-3.612l1.641-7.931a2.987,2.987,0,0,1,2.98-2.389q7.444.127,15.124.195,8.959.083,16.16.08,9.276,0,12.719-2.08t3.44-8.16a15.6,15.6,0,0,0-.4-3.6,6.471,6.471,0,0,0-1.6-2.96,9.3,9.3,0,0,0-3.44-2.159,22.276,22.276,0,0,0-6.08-1.2l-19.2-1.759a28.511,28.511,0,0,1-10.081-2.481,20.351,20.351,0,0,1-6.72-4.96,19.1,19.1,0,0,1-3.76-6.64,24.1,24.1,0,0,1-1.2-7.52v-2.72q0-10.879,7.519-17.04t24.641-6.16h16q6.855,0,15.126.218a3.007,3.007,0,0,1,2.868,3.608l-1.648,7.965a3.008,3.008,0,0,1-3.012,2.392q-5.192-.117-9.334-.183-5.124-.079-9.041-.08h-12.72q-8.16,0-11.36,2t-3.2,7.12a15.161,15.161,0,0,0,.4,3.68,5.419,5.419,0,0,0,1.6,2.72,9.792,9.792,0,0,0,3.519,1.92,25.924,25.924,0,0,0,6.16,1.121Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M807.368,139.225q-18.084,0-27.2-6.079t-9.12-20.8v-55.4a3,3,0,0,1,3-3h10.8a3,3,0,0,1,3,3v52.04a45.592,45.592,0,0,0,.481,7.04,9.548,9.548,0,0,0,2.4,5.121,11.909,11.909,0,0,0,5.84,3.119,43.939,43.939,0,0,0,10.8,1.04,42.954,42.954,0,0,0,10.72-1.04,11.86,11.86,0,0,0,5.759-3.119,9.542,9.542,0,0,0,2.4-5.121,45.6,45.6,0,0,0,.48-7.04V56.945a3,3,0,0,1,3-3h10.8a3,3,0,0,1,3,3v55.4q0,14.722-9.119,20.8T807.368,139.225Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M871.485,136.665a3,3,0,0,1-3-3V80.025a30.025,30.025,0,0,1,2.24-12.24,20.586,20.586,0,0,1,6.32-8.16,26.6,26.6,0,0,1,9.841-4.56,52.827,52.827,0,0,1,12.8-1.44h11.84q1.766,0,3.272.029a3,3,0,0,1,2.889,3.608l-1.661,8.028a2.982,2.982,0,0,1-2.958,2.385c-3.782-.046-10.7-.13-11.782-.13a29.591,29.591,0,0,0-8.8,1.04,9.58,9.58,0,0,0-4.8,3.12,10.466,10.466,0,0,0-2,5.12,53.127,53.127,0,0,0-.4,6.88v49.96a3,3,0,0,1-3,3Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M1005.484,122.905q0,7.68-3.519,10.72t-12.8,3.04h-24q-16.8,0-24.08-6.16t-7.279-18.48v-3.52q0-13.44,7.919-19.2t24.72-5.76q9.6,0,15.04,1.52,2.228.624,3.972,1.286a2.98,2.98,0,0,0,4.028-2.8v-.006a37.939,37.939,0,0,0-.56-6.96,8.83,8.83,0,0,0-2.72-4.96,14.269,14.269,0,0,0-6.239-3.04,47.051,47.051,0,0,0-11.121-1.04q-6.72,0-14.32.08-5.1.056-9.235.145a3,3,0,0,1-2.989-3.64l1.725-7.9a3,3,0,0,1,2.842-2.358q3.757-.105,8.7-.167,6.56-.079,13.28-.08,19.359,0,28,6.8t8.64,20.08Zm-56-11.04q0,5.6,3.36,8.4t12.32,2.8h16.32a8,8,0,0,0,8-8v-6.72a19.419,19.419,0,0,0-.64-5.28,6.48,6.48,0,0,0-2.56-3.6,13.934,13.934,0,0,0-5.6-2,59.539,59.539,0,0,0-9.759-.64h-3.68a56.05,56.05,0,0,0-8.72.56,13.564,13.564,0,0,0-5.44,1.92,7.174,7.174,0,0,0-2.8,3.6,16.816,16.816,0,0,0-.8,5.6Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M88.2,108.927c0,15.986-9.4,28.946-21,28.946s-21-12.96-21-28.946c0-7.118,2.917-20.375,7.537-32.932A279.7,279.7,0,0,1,67.195,45.817,308.168,308.168,0,0,1,80.984,76.294C85.9,89.437,88.2,101.415,88.2,108.927Z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M599.592,31.527c0-15.987-9.4-28.946-21-28.946s-21,12.959-21,28.946c0,7.118,2.917,20.375,7.537,32.931a279.662,279.662,0,0,0,13.463,30.179A308.168,308.168,0,0,0,592.381,64.16C597.3,51.017,599.592,39.039,599.592,31.527Z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-char",class:_vm.headerBg},[_c(_vm.logoComponent,{tag:"component",staticStyle:{"margin":"15px"}}),_vm._v(" "),_c('div',{attrs:{"id":"nav-drawer"}},[_c('input',{staticClass:"nav-unshown",attrs:{"id":"nav-input","type":"checkbox"}}),_vm._v(" "),_c('label',{class:_vm.headerContent,attrs:{"id":"nav-open","for":"nav-input"}},[_c('span')]),_vm._v(" "),_c('label',{staticClass:"nav-unshown",attrs:{"id":"nav-close","for":"nav-input"}}),_vm._v(" "),_c('div',{attrs:{"id":"nav-content"}},[(!_vm.isLoggedIn)?[_c('div',{staticClass:"header-menu-item"},[_c('router-link',{staticClass:"header-char",attrs:{"to":"/signin"}},[_vm._v("ログイン")])],1),_vm._v(" "),_c('div',{staticClass:"header-menu-item"},[_c('router-link',{staticClass:"header-char",attrs:{"to":"/signup"}},[_vm._v("新規登録")])],1)]:_vm._e(),_vm._v(" "),[_c('div',{staticClass:"header-menu-item"},[_c('router-link',{staticClass:"header-char",attrs:{"id":"tsurai","to":{name: 'Timeline', params: {mode: 'tsurai'}}}},[_vm._v("つらいTL")])],1)],_vm._v(" "),[_c('div',{staticClass:"header-menu-item"},[_c('router-link',{staticClass:"header-char",attrs:{"id":"erai","to":{name: 'Timeline', params: {mode: 'erai'}}}},[_vm._v("えらいTL")])],1)],_vm._v(" "),(_vm.isLoggedIn)?[_c('div',{staticClass:"header-menu-item"},[_c('router-link',{staticClass:"header-char",attrs:{"id":"mypage","to":{name: 'UserPage', params: {id: _vm.userAuthId}}}},[_vm._v("マイページ")])],1)]:_vm._e(),_vm._v(" "),[_c('div',{staticClass:"header-menu-item"},[_c('router-link',{staticClass:"header-char",attrs:{"id":"about","to":{name: 'About'}}},[_vm._v("About")])],1)],_vm._v(" "),(_vm.isLoggedIn)?[_c('div',{staticClass:"header-menu-item"},[_c('router-link',{staticClass:"header-char",attrs:{"id":"contact","to":{name: 'Contact'}}},[_vm._v("Contact")])],1)]:_vm._e(),_vm._v(" "),[_c('div',{staticClass:"header-menu-item"},[(_vm.isLoggedIn)?_c('a',{staticClass:"header-char",attrs:{"id":"logout"},on:{"click":_vm.signOut}},[_vm._v("ログアウト")]):_vm._e()])]],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"now-loading"},[_c('h2',[_vm._v(" Now Loading ... ")]),_vm._v(" "),_c('v-icon',{attrs:{"name":"sync","scale":"3","spin":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostingButton_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a54040_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostingButton_vue__ = __webpack_require__(521);
function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17a54040"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostingButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a54040_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostingButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 520:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"fab",class:_vm.postButtonStyle,attrs:{"id":"fab"},on:{"click":function($event){return _vm.clickItem()}}},[_c('v-icon',{staticClass:"icon",attrs:{"name":"pencil-alt","scale":"2","color":"#ffffff"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.timelineBg},[_c('div',{attrs:{"id":"header"}},[_c('common-header',{key:_vm.mode,attrs:{"is-logged-in":_vm.isLoggedIn,"mode":_vm.mode}})],1),_vm._v(" "),(_vm.isLoading)?_c('now-loading'):_vm._e(),_vm._v(" "),_c('posting-button',{staticClass:"posting-button",attrs:{"mode":_vm.mode},on:{"popPost":function($event){return _vm.popPost()}}}),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"row"},[(_vm.isLoggedIn)?_c('div',{staticClass:"col-lg-3",attrs:{"id":"submit-post"}},[_c('post-submit-form',{attrs:{"mode":_vm.mode,"is-mobile":_vm.isMobile,"show-modal":_vm.showPostModal},on:{"close":function($event){return _vm.closeModal()}}})],1):_vm._e(),_vm._v(" "),(!_vm.isLoggedIn)?_c('div',{staticClass:"col-lg-3"}):_vm._e(),_vm._v(" "),(_vm.mode==='tsurai')?_c('div',{staticClass:"col-lg-6",attrs:{"id":"timeline"}},[_vm._l((_vm.posts),function(post,index){return _c('show-tsurai-timeline',{key:index,attrs:{"post":post}})}),_vm._v(" "),_c('infinity-loading',{on:{"infinite":_vm.infiniteHandler}})],2):_vm._e(),_vm._v(" "),(_vm.mode==='erai')?_c('div',{staticClass:"col-lg-6",attrs:{"id":"timeline"}},[_vm._l((_vm.posts),function(post,index){return _c('show-erai-timeline',{key:index,attrs:{"post":post}})}),_vm._v(" "),_c('infinity-loading',{on:{"infinite":_vm.infiniteHandler}})],2):_vm._e()]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e9c5648_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(526);
function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e9c5648"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e9c5648_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 525:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-header',{attrs:{"is-logged-in":_vm.isLoggedIn,"mode":"other"}}),_vm._v(" "),_c('div',{staticClass:"signup container"},[_c('h2',[_vm._v(" ユーザー登録 ")]),_vm._v(" "),_c('div',{staticClass:"form-horizontal",attrs:{"id":"signup"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.addUserInfo($event)}}},[_c('fieldset',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8 signup-form"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"text","id":"registerUsername","placeholder":"ハンドルネーム"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8 signup-form"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"text","id":"registerEmail","placeholder":"メールアドレス"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8 signup-form"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twitter),expression:"twitter"}],staticClass:"form-control",attrs:{"type":"text","id":"registerTwitterID","placeholder":"Twitter ID(任意)"},domProps:{"value":(_vm.twitter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twitter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8 signup-form"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"registerPassword","placeholder":"パスワード"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-8 signup-form"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordConfirm),expression:"passwordConfirm"}],staticClass:"form-control",attrs:{"type":"password","id":"confirmPassword","placeholder":"パスワード(確認)"},domProps:{"value":(_vm.passwordConfirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordConfirm=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 signup-form"},[_c('b-button',{attrs:{"disable":_vm.isProcessing,"variant":"info","type":"submit"}},[_vm._v("登録")]),_vm._v(" "),(_vm.isProcessing)?_c('v-icon',{attrs:{"name":"sync","scale":"1.3","spin":""}}):_vm._e()],1)])])]),_vm._v(" "),_c('p',[_vm._v(" アカウントをお持ちですか?\n            "),_c('router-link',{attrs:{"to":"/signin"}},[_vm._v("ログイン")])],1),_vm._v(" "),_c('b-button',{attrs:{"disable":_vm.isProcessing,"variant":"danger"},on:{"click":_vm.signInWithGoogle}},[_vm._v("Googleでログイン")]),_vm._v(" "),_c('b-button',{attrs:{"disable":_vm.isProcessing,"variant":"primary"},on:{"click":_vm.signInWithTwitter}},[_vm._v("Twitterでログイン")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aa153d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(529);
function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6aa153d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aa153d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 528:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-header',{attrs:{"is-logged-in":_vm.isLoggedIn,"mode":"other"}}),_vm._v(" "),_c('div',{staticClass:"signin container"},[_c('h2',[_vm._v("ログイン")]),_vm._v(" "),_c('div',{staticClass:"form-horizontal",attrs:{"id":"signin"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.confirmUserInfo($event)}}},[_c('fieldset',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 signin-form"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"input","id":"confirmUsername","placeholder":"メールアドレス"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 signin-form"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","id":"confirmPassword","placeholder":"パスワード"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 signin-form"},[_c('b-button',{attrs:{"disable":_vm.isProcessing,"variant":"info","type":"submit"}},[_vm._v("ログイン")]),_vm._v(" "),(_vm.isProcessing)?_c('v-icon',{attrs:{"name":"sync","scale":"1.3","spin":""}}):_vm._e()],1)])])]),_vm._v(" "),_c('p',[_vm._v(" アカウントをお持ちではないですか？\n            "),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v("登録")])],1),_vm._v(" "),_c('b-button',{attrs:{"disable":_vm.isProcessing,"variant":"danger"},on:{"click":function($event){return _vm.signInWithGoogle()}}},[_vm._v("Googleでログイン")]),_vm._v(" "),_c('b-button',{attrs:{"disable":_vm.isProcessing,"variant":"primary"},on:{"click":function($event){return _vm.signInWithTwitter()}}},[_vm._v("Twitterでログイン")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPage_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_202691d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPage_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-202691d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_202691d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 531:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageUploadForm_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa41fc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageUploadForm_vue__ = __webpack_require__(540);
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageUploadForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3aa41fc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageUploadForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-upload"},[_c('div',{staticClass:"form-group upload-form"},[_c('croppa',{attrs:{"placeholder-font-size":_vm.fontSize,"file-size-limit":_vm.maxFileSize},model:{value:(_vm.iconCroppa),callback:function ($$v) {_vm.iconCroppa=$$v},expression:"iconCroppa"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"user-info"}},[_c('common-header',{attrs:{"is-logged-in":_vm.isLoggedIn,"mode":"other"}}),_vm._v(" "),(_vm.isLoading)?_c('now-loading'):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-top"},[_c('img',{attrs:{"src":_vm.visitedUserInfo.icon_URL,"width":"60%"}}),_vm._v(" "),(!_vm.isEditing)?_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("ハンドルネーム")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.visitedUserInfo.username))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v(" Twitter ID ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":_vm.twitterLink}},[_vm._v(" "+_vm._s(_vm.visitedUserInfo.twitter)+" ")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v(" 自己紹介 ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.visitedUserInfo.bio)+" ")])])]),_vm._v(" "),(_vm.isMyPage)?_c('b-button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.editProfile()}}},[_vm._v("編集")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isEditing)?_c('form',[_c('fieldset',{staticClass:"row"},[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("ハンドルネーム")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visitedUserInfo.username),expression:"visitedUserInfo.username"}],staticClass:"form-control",attrs:{"type":"text","id":"editUsername"},domProps:{"value":(_vm.visitedUserInfo.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.visitedUserInfo, "username", $event.target.value)}}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Twitter ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visitedUserInfo.twitter),expression:"visitedUserInfo.twitter"}],staticClass:"form-control",attrs:{"type":"text","id":"editTwitterID"},domProps:{"value":(_vm.visitedUserInfo.twitter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.visitedUserInfo, "twitter", $event.target.value)}}})]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("自己紹介")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visitedUserInfo.bio),expression:"visitedUserInfo.bio"}],staticClass:"form-control",attrs:{"type":"textarea","id":"editBio"},domProps:{"value":(_vm.visitedUserInfo.bio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.visitedUserInfo, "bio", $event.target.value)}}})])])]),_vm._v(" "),_c('image-upload-form',{ref:"ImageUploadForm",attrs:{"user-id":_vm.visitingUserInfo.user_id}}),_vm._v(" "),(_vm.isMyPage)?_c('b-button',{staticClass:"btn btn-info",attrs:{"type":"button"},on:{"click":function($event){return _vm.completeEdit()}}},[_vm._v("完了")]):_vm._e()],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-top"},[_c('b-tabs',{attrs:{"content-class":"mt-2"}},[_c('b-tab',{attrs:{"title":"つらいTL","active":""}},[_vm._l((_vm.userTsuraiPosts),function(post,index){return _c('show-tsurai-timeline',{key:index,attrs:{"post":post}})}),_vm._v(" "),_c('infinity-loading',{on:{"infinite":_vm.infiniteTsuraiHandler}})],2),_vm._v(" "),_c('b-tab',{attrs:{"title":"えらいTL"}},[_vm._l((_vm.userEraiPosts),function(post,index){return _c('show-erai-timeline',{key:index,attrs:{"post":post}})}),_vm._v(" "),_c('infinity-loading',{on:{"infinite":_vm.infiniteEraiHandler}})],2)],1)],1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89454c5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(544);
function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-89454c5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89454c5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 543:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-header',{attrs:{"is-logged-in":_vm.isLoggedIn,"mode":"other"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h1',{staticStyle:{"margin":"30px"}},[_vm._v(" About ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"100rem"},attrs:{"title":"いんぐらむ","sub-title":"プログラマー"}},[_c('b-card-text',[_vm._v("\n                    このSNSを作りはじめた人です。\n                ")]),_vm._v(" "),_c('b-link',{staticClass:"card-link",attrs:{"href":"https://twitter.com/kazuokiriyama_"}},[_vm._v(" @kazuokiriyama_ ")])],1),_vm._v(" "),_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"100rem"},attrs:{"title":"TEICA","sub-title":"デザイナー"}},[_c('b-card-text',[_vm._v("\n                    ねこです、よろしくお願いします。\n                ")]),_vm._v(" "),_c('b-link',{staticClass:"card-link",attrs:{"href":"https://twitter.com/teiflower"}},[_vm._v(" @teiflower ")])],1)],1),_vm._v(" "),_c('p',[_vm._v(" 一緒に開発してくれる人を募集しています！ ")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-about"},[_c('p',{staticClass:"about-sentence",attrs:{"align":"left"}},[_vm._v("このサイトは「つらい人の、つらい人による、つらい人のためのSNS」を目指して作られたSNS、"),_c('b',[_vm._v("TsuraTsura")]),_vm._v("です。\n            ")]),_vm._v(" "),_c('p',{staticClass:"about-sentence",attrs:{"align":"left"}},[_c('b',[_vm._v("つらいTL")]),_vm._v("では今日あったつらいことを投稿してみましょう。しばらくすれば他のユーザーから\n                労いや慰めのスタンプが届くことでしょう。スタンプの意味は左から「それはつらい」「よしよし」「頑張ったね」です。\n            ")]),_vm._v(" "),_c('p',{staticClass:"about-sentence",attrs:{"align":"left"}},[_c('b',[_vm._v("えらいTL")]),_vm._v("では今日成し遂げたえらいことを（どんなに些細なことでも！）投稿してみましょう。\n                しばらくすれば他のユーザーから賞賛のスタンプが届くことでしょう。スタンプの意味は左から「すごい！」「おめでとう！」「天才か？」です。\n            ")]),_vm._v(" "),_c('p',{staticClass:"about-sentence",attrs:{"align":"left"}},[_vm._v("\n                このSNSはお互いのつらいこと、えらいことを共有することに特化しています。ダイレクトメッセージ、画像投稿、リプライ、誰がスタンプを押したかの確認などは悩んだ末に実装しない方針をとりました。\n            ")]),_vm._v(" "),_c('p',{staticClass:"about-sentence",attrs:{"align":"left"}},[_vm._v("\n                匿名性の高い空間で、穏やかに、ひっそりとささやかな交流がなされることを願っています。\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e0e123e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(546);
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e0e123e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-header',{attrs:{"is-logged-in":_vm.isLoggedIn,"mode":"other"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h1',{staticStyle:{"margin":"30px"}},[_vm._v(" Contact ")]),_vm._v(" "),_c('p',[_vm._v("バグの報告・要望・改善要求などを書いてください。")]),_vm._v(" "),_c('p',[_vm._v("報告はログインしているユーザーのみが行なえます。")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.report($event)}}},[_c('fieldset',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 offset-lg-3"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reportText),expression:"reportText"}],staticClass:"form-control",attrs:{"id":"reportText","rows":"5","placeholder":"報告内容"},domProps:{"value":(_vm.reportText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reportText=$event.target.value}}}),_vm._v(" "),_c('b-button',{staticClass:"button",staticStyle:{"margin":"10px"},attrs:{"disable":_vm.isProcessing,"type":"submit"}},[_vm._v("完了")])],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var db = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.firestore();

var snapshot2PostData = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(snapshot, mode) {
    var data, authorPromiseList, authorList;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = Array(0);
            authorPromiseList = [];

            snapshot.forEach(function (doc) {
              authorPromiseList.push(doc.author.get());
            });
            authorList = [];
            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(authorPromiseList).then(function (a) {
              authorList = a;
            });

          case 6:
            if (mode === 'tsurai') {
              snapshot.forEach(function (doc, idx) {
                var author = authorList[idx];
                var authorData = author.data();
                if (authorData === undefined) return;
                authorData.user_id = author.id;

                // それはつらいスタンプ
                var tooBadRefList = doc.that_is_too_bad_list;
                var tooBadUserList = [];
                for (var i = 0; i < tooBadRefList.length; i++) {
                  var userDoc = tooBadRefList[i];
                  var userId = userDoc.id;
                  tooBadUserList.push(userId);
                }
                doc.too_bad_id_list = tooBadUserList;

                // よしよしスタンプ
                var alrightRefList = doc.you_are_alright_list;
                var alrightUserList = [];
                for (var _i = 0; _i < alrightRefList.length; _i++) {
                  var _userDoc = alrightRefList[_i];
                  var _userId = _userDoc.id;
                  alrightUserList.push(_userId);
                }
                doc.alright_id_list = alrightUserList;

                // 頑張ったねスタンプ
                var goodJobRefList = doc.good_job_list;
                var goodJobUserList = [];
                for (var _i2 = 0; _i2 < goodJobRefList.length; _i2++) {
                  var _userDoc2 = goodJobRefList[_i2];
                  var _userId2 = _userDoc2.id;
                  goodJobUserList.push(_userId2);
                }
                doc.good_job_id_list = goodJobUserList;
                data.push({ posts: doc, author: authorData, uid: doc.id });
              });
            }
            if (mode === 'erai') {
              snapshot.forEach(function (doc, idx) {
                var author = authorList[idx];
                var authorData = author.data();
                if (authorData === undefined) return;
                authorData.user_id = author.id;

                // すごいスタンプ
                var greatRefList = doc.great_list;
                var greatUserList = [];
                for (var i = 0; i < greatRefList.length; i++) {
                  var userDoc = greatRefList[i];
                  var userId = userDoc.id;
                  greatUserList.push(userId);
                }
                doc.great_id_list = greatUserList;

                // おめでとうスタンプ
                var congratRefList = doc.congrat_list;
                var congratUserList = [];
                for (var _i3 = 0; _i3 < congratRefList.length; _i3++) {
                  var _userDoc3 = congratRefList[_i3];
                  var _userId3 = _userDoc3.id;
                  congratUserList.push(_userId3);
                }
                doc.congrat_id_list = congratUserList;

                // 天才スタンプ
                var geniusRefList = doc.genius_list;
                var geniusUserList = [];
                for (var _i4 = 0; _i4 < geniusRefList.length; _i4++) {
                  var _userDoc4 = geniusRefList[_i4];
                  var _userId4 = _userDoc4.id;
                  geniusUserList.push(_userId4);
                }
                doc.genius_id_list = geniusUserList;
                data.push({ posts: doc, author: authorData, uid: doc.id });
              });
            }
            return _context.abrupt('return', data);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function snapshot2PostData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getUser = function getUser(userAuthId) {
  var userDoc = db.collection('users').where('auth_id', '==', userAuthId);
  var data = userDoc.get().then(function (snapshot) {
    var data = {};
    var index = '';
    snapshot.forEach(function (doc) {
      data = doc.data();
      index = doc.id;
    });
    data.user_id = index;
    return data;
  });
  return data;
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  state: {
    postsTsurai: {},
    postsErai: {},
    isLoggedIn: false,
    userInfo: {},
    postsWithCondition: {},
    visitedUserInfo: {}
  },
  mutations: {
    setTsuraiTimeline: function setTsuraiTimeline(state, payload) {
      state.postsTsurai = payload.data;
    },
    setEraiTimeline: function setEraiTimeline(state, payload) {
      state.postsErai = payload.data;
    },
    setLoginState: function setLoginState(state, payload) {
      state.isLoggedIn = payload.loginState;
    },
    setUserInfoState: function setUserInfoState(state, payload) {
      state.userInfo = payload.data;
    },
    setVisitedUserInfoState: function setVisitedUserInfoState(state, payload) {
      state.visitedUserInfo = payload.data;
    },
    setTimelineWithCondition: function setTimelineWithCondition(state, payload) {
      state.postsWithCondition = payload.data;
    }
  },
  actions: {
    getTsuraiTimeline: function getTsuraiTimeline(state, payload) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newPosts, numPosts, num, snapshot, _newPosts, postData, _postData;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newPosts = [];
                numPosts = 0;

                if (payload !== undefined) {
                  newPosts = payload.newPosts;
                  numPosts = payload.numPosts;
                } else {
                  newPosts = undefined;
                  numPosts = undefined;
                }

                if (!(newPosts === undefined)) {
                  _context2.next = 16;
                  break;
                }

                num = numPosts !== undefined ? numPosts : 20;
                _context2.next = 7;
                return db.collection('posts').orderBy('created_at', 'desc').limit(num).get();

              case 7:
                snapshot = _context2.sent;
                _newPosts = [];

                snapshot.forEach(function (doc) {
                  var docData = doc.data();
                  docData.id = doc.id;
                  _newPosts.push(docData);
                });
                _context2.next = 12;
                return snapshot2PostData(_newPosts, 'tsurai');

              case 12:
                postData = _context2.sent;

                _this.commit('setTsuraiTimeline', { data: postData });
                _context2.next = 20;
                break;

              case 16:
                _context2.next = 18;
                return snapshot2PostData(newPosts, 'tsurai');

              case 18:
                _postData = _context2.sent;

                _this.commit('setTsuraiTimeline', { data: _postData });

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    getEraiTimeline: function getEraiTimeline(state, payload) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newPosts, numPosts, num, snapshot, _newPosts2, postData, _postData2;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newPosts = [];
                numPosts = 0;

                if (payload !== undefined) {
                  newPosts = payload.newPosts;
                  numPosts = payload.numPosts;
                } else {
                  newPosts = undefined;
                  numPosts = undefined;
                }

                if (!(newPosts === undefined)) {
                  _context3.next = 16;
                  break;
                }

                num = numPosts !== undefined ? numPosts : 20;
                _context3.next = 7;
                return db.collection('posts_erai').orderBy('created_at', 'desc').limit(num).get();

              case 7:
                snapshot = _context3.sent;
                _newPosts2 = [];

                snapshot.forEach(function (doc) {
                  var docData = doc.data();
                  docData.id = doc.id;
                  _newPosts2.push(docData);
                });
                _context3.next = 12;
                return snapshot2PostData(_newPosts2, 'erai');

              case 12:
                postData = _context3.sent;

                _this2.commit('setEraiTimeline', { data: postData });
                _context3.next = 20;
                break;

              case 16:
                _context3.next = 18;
                return snapshot2PostData(newPosts, 'erai');

              case 18:
                _postData2 = _context3.sent;

                _this2.commit('setEraiTimeline', { data: _postData2 });

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    getLoginState: function getLoginState() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  var unsubscribe = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().onAuthStateChanged(function (user) {
                    _this3.commit('setLoginState', { loginState: !!user });
                    unsubscribe();
                    resolve();
                  });
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    getUserInfoState: function getUserInfoState() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  var unsubscribe = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().onAuthStateChanged(function () {
                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(user) {
                      var userData;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (!user) {
                                _context5.next = 5;
                                break;
                              }

                              _context5.next = 3;
                              return getUser(user.uid);

                            case 3:
                              userData = _context5.sent;

                              _this4.commit('setUserInfoState', { data: userData });

                            case 5:
                              unsubscribe();
                              resolve();

                            case 7:
                            case 'end':
                              return _context5.stop();
                          }
                        }
                      }, _callee5, _this4);
                    }));

                    return function (_x3) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                });

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    getVisitedUserInfoState: function getVisitedUserInfoState(state, userAuthId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  var unsubscribe = __WEBPACK_IMPORTED_MODULE_5_firebase___default.a.auth().onAuthStateChanged(function () {
                    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(user) {
                      var visitedUserData;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              _context7.next = 2;
                              return getUser(userAuthId);

                            case 2:
                              visitedUserData = _context7.sent;

                              _this5.commit('setVisitedUserInfoState', { data: visitedUserData });
                              unsubscribe();
                              resolve();

                            case 6:
                            case 'end':
                              return _context7.stop();
                          }
                        }
                      }, _callee7, _this5);
                    }));

                    return function (_x4) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                });

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this5);
      }))();
    }
  }
}));

/***/ })

},[358]);


// WEBPACK FOOTER //
// static/js/app.9b958f42d9b008839c01.js